/**
 * Auto-generated by IconRegistryGenerator
 * DO NOT EDIT THIS FILE MANUALLY.
 */
import { ComponentType, SVGProps } from 'react';
import iconLazy from "../lazy";

const AgenticAiAgents = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-AgenticAiAgents" */ '../../components/outline/AgenticAiAgents')
);
const AgenticAiApps = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-AgenticAiApps" */ '../../components/outline/AgenticAiApps')
);
const AgenticAiChat = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-AgenticAiChat" */ '../../components/outline/AgenticAiChat')
);
const AgenticAiPeople = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-AgenticAiPeople" */ '../../components/outline/AgenticAiPeople')
);
const AgenticAiSearch = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-AgenticAiSearch" */ '../../components/outline/AgenticAiSearch')
);
const AISummary = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-AISummary" */ '../../components/outline/AiSummary')
);
const AlertCircle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-AlertCircle" */ '../../components/outline/AlertCircle')
);
const AlertTriangle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-AlertTriangle" */ '../../components/outline/AlertTriangle')
);
const Announcement03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Announcement03" */ '../../components/outline/Announcement03')
);
const Archive = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Archive" */ '../../components/outline/Archive')
);
const ArrowCircleBrokenDownRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowCircleBrokenDownRight" */ '../../components/outline/ArrowCircleBrokenDownRight')
);
const ArrowCircleBrokenRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowCircleBrokenRight" */ '../../components/outline/ArrowCircleBrokenRight')
);
const ArrowCircleBrokenUpRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowCircleBrokenUpRight" */ '../../components/outline/ArrowCircleBrokenUpRight')
);
const ArrowCircleRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowCircleRight" */ '../../components/outline/ArrowCircleRight')
);
const ArrowCircleUpLeft = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowCircleUpLeft" */ '../../components/outline/ArrowCircleUpLeft')
);
const ArrowDown = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowDown" */ '../../components/outline/ArrowDown')
);
const ArrowDownToLine = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowDownToLine" */ '../../components/outline/ArrowDownToLine')
);
const ArrowLeft = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowLeft" */ '../../components/outline/ArrowNarrowLeft')
);
const ArrowLeftToLine = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowLeftToLine" */ '../../components/outline/ArrowLeftToLine')
);
const ArrowNarrowDown = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowNarrowDown" */ '../../components/outline/ArrowNarrowDown')
);
const ArrowNarrowRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowNarrowRight" */ '../../components/outline/ArrowNarrowRight')
);
const ArrowRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowRight" */ '../../components/outline/ArrowNarrowRight')
);
const ArrowRightToLine = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowRightToLine" */ '../../components/outline/ArrowRightToLine')
);
const ArrowsDown = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowsDown" */ '../../components/outline/ArrowsDown')
);
const ArrowSquareUpRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowSquareUpRight" */ '../../components/outline/ArrowSquareUpRight')
);
const ArrowsRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowsRight" */ '../../components/outline/ArrowsRight')
);
const ArrowsUp = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowsUp" */ '../../components/outline/ArrowsUp')
);
const ArrowUp = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowUp" */ '../../components/outline/ArrowUp')
);
const ArrowUpToLine = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ArrowUpToLine" */ '../../components/outline/ArrowUpToLine')
);
const Atom02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Atom02" */ '../../components/outline/Atom02')
);
const AtSign = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-AtSign" */ '../../components/outline/AtSign')
);
const BarChart10 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-BarChart10" */ '../../components/outline/BarChart10')
);
const BellNotification = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-BellNotification" */ '../../components/outline/BellNotification')
);
const Bloomberg = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Bloomberg" */ '../../components/colored/Bloomberg')
);
const BracketsCheck = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-BracketsCheck" */ '../../components/outline/BracketsCheck')
);
const BracketsEllipses = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-BracketsEllipses" */ '../../components/outline/BracketsEllipses')
);
const BracketsSquare = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-BracketsSquare" */ '../../components/outline/BracketsSquare')
);
const BriefCase02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-BriefCase02" */ '../../components/outline/Briefcase02')
);
const Bug = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Bug" */ '../../components/outline/Bug')
);
const Calendar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Calendar" */ '../../components/outline/Calendar')
);
const Chat = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Chat" */ '../../components/outline/Chat')
);
const CheckCircleBroken = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-CheckCircleBroken" */ '../../components/outline/CheckCircleBroken')
);
const CheckHeart = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-CheckHeart" */ '../../components/outline/CheckHeart')
);
const ChevronDown = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ChevronDown" */ '../../components/outline/ChevronDown')
);
const ChevronDownDouble = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ChevronDownDouble" */ '../../components/outline/ChevronDownDouble')
);
const ChevronDownSm = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ChevronDownSm" */ '../../components/outline/ChevronDownSm')
);
const ChevronLeft = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ChevronLeft" */ '../../components/outline/ChevronLeft')
);
const ChevronLeftDouble = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ChevronLeftDouble" */ '../../components/outline/ChevronLeftDouble')
);
const ChevronRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ChevronRight" */ '../../components/outline/ChevronRight')
);
const ChevronRightDouble = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ChevronRightDouble" */ '../../components/outline/ChevronRightDouble')
);
const ChevronSelectorVertical = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ChevronSelectorVertical" */ '../../components/outline/ChevronSelectorVertical')
);
const ChevronUp = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ChevronUp" */ '../../components/outline/ChevronUp')
);
const ChevronUpDouble = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ChevronUpDouble" */ '../../components/outline/ChevronUpDouble')
);
const Clock = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Clock" */ '../../components/outline/Clock')
);
const ClockFastForward = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ClockFastForward" */ '../../components/outline/ClockFastForward')
);
const ClockStopwatch = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ClockStopwatch" */ '../../components/outline/ClockStopwatch')
);
const Code01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Code01" */ '../../components/outline/Code01')
);
const Code02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Code02" */ '../../components/outline/Code02')
);
const Codepen = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Codepen" */ '../../components/outline/Codepen')
);
const Coins03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Coins03" */ '../../components/outline/Coins03')
);
const CoinsStacked04 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-CoinsStacked04" */ '../../components/outline/CoinsStacked04')
);
const Container = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Container" */ '../../components/outline/Container')
);
const Copy01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Copy01" */ '../../components/outline/Copy01')
);
const Cross = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Cross" */ '../../components/outline/X')
);
const Csv = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Csv" */ '../../components/colored/Csv')
);
const Cube02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Cube02" */ '../../components/outline/Cube02')
);
const CursorInteractive = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-CursorInteractive" */ '../../components/outline/CursorInteractive')
);
const CustomConnector01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-CustomConnector01" */ '../../components/outline/CustomConnector01')
);
const Database01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Database01" */ '../../components/outline/Database01')
);
const Dataflow02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Dataflow02" */ '../../components/outline/Dataflow02')
);
const Dataflow04 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Dataflow04" */ '../../components/outline/Dataflow04')
);
const DataTypeArray = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeArray" */ '../../components/outline/data-types/DataTypeArray')
);
const DataTypeArrayZero = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeArrayZero" */ '../../components/outline/data-types/DataTypeArrayZero')
);
const DataTypeBinary = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeBinary" */ '../../components/outline/data-types/DataTypeBinary')
);
const DataTypeBoolean = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeBoolean" */ '../../components/outline/data-types/DataTypeBoolean')
);
const DataTypeDate = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeDate" */ '../../components/outline/data-types/DataTypeDate')
);
const DataTypeDatetime = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeDatetime" */ '../../components/outline/data-types/DataTypeDatetime')
);
const DataTypeDecimal = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeDecimal" */ '../../components/outline/data-types/DataTypeDecimal')
);
const DataTypeDouble = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeDouble" */ '../../components/outline/data-types/DataTypeDouble')
);
const DataTypeInteger = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeInteger" */ '../../components/outline/data-types/DataTypeInteger')
);
const DataTypeObject = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeObject" */ '../../components/outline/data-types/DataTypeObject')
);
const DataTypeText = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeText" */ '../../components/outline/data-types/DataTypeText')
);
const DataTypeTime = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeTime" */ '../../components/outline/data-types/DataTypeTime')
);
const DataTypeTimestamp = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DataTypeTimestamp" */ '../../components/outline/data-types/DataTypeTimestamp')
);
const Decimal = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Decimal" */ '../../components/outline/Decimal')
);
const Doc = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Doc" */ '../../components/colored/Doc')
);
const Docx = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Docx" */ '../../components/colored/Docx')
);
const DotsHorizontal = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DotsHorizontal" */ '../../components/outline/DotsHorizontal')
);
const DotsVertical = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DotsVertical" */ '../../components/outline/DotsVertical')
);
const Double = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Double" */ '../../components/outline/data-types/DataTypeDouble')
);
const DualAxesLineChartUp01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-DualAxesLineChartUp01" */ '../../components/outline/DualAxesLineChartUp01')
);
const Edit01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Edit01" */ '../../components/outline/Edit01')
);
const Edit05 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Edit05" */ '../../components/outline/Edit05')
);
const Epubs = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Epubs" */ '../../components/colored/Epubs')
);
const ErrorOutline = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ErrorOutline" */ '../../components/outline/ErrorOutline')
);
const Facebook = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Facebook" */ '../../components/colored/Facebook')
);
const FaceSmile = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-FaceSmile" */ '../../components/outline/FaceSmile')
);
const File05 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-File05" */ '../../components/outline/File05')
);
const FileDownload03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-FileDownload03" */ '../../components/outline/FileDownload03')
);
const FileShield02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-FileShield02" */ '../../components/outline/FileShield02')
);
const FileX03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-FileX03" */ '../../components/outline/FileX03')
);
const FilterLines = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-FilterLines" */ '../../components/outline/FilterLines')
);
const FolderColored = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-FolderColored" */ '../../components/colored/Folder')
);
const Gauge = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Gauge" */ '../../components/outline/Gauge')
);
const GitBranch01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-GitBranch01" */ '../../components/outline/GitBranch01')
);
const Globe01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Globe01" */ '../../components/outline/Globe01')
);
const GoogleMaps = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-GoogleMaps" */ '../../components/colored/GoogleMaps')
);
const Governance = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Governance" */ '../../components/outline/Governance')
);
const GridDotsBottom = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-GridDotsBottom" */ '../../components/outline/GridDotsBottom')
);
const GridDotsLeft = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-GridDotsLeft" */ '../../components/outline/GridDotsLeft')
);
const GridDotsOuter = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-GridDotsOuter" */ '../../components/outline/GridDotsOuter')
);
const GridDotsRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-GridDotsRight" */ '../../components/outline/GridDotsRight')
);
const GridDotsTop = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-GridDotsTop" */ '../../components/outline/GridDotsTop')
);
const Hash01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Hash01" */ '../../components/outline/Hash01')
);
const Heart = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Heart" */ '../../components/outline/Heart')
);
const HeartFilled = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-HeartFilled" */ '../../components/solid/HeartFilled')
);
const HelpCircle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-HelpCircle" */ '../../components/outline/HelpCircle')
);
const Home01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Home01" */ '../../components/outline/Home01')
);
const Home02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Home02" */ '../../components/outline/Home02')
);
const Home03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Home03" */ '../../components/outline/Home03')
);
const Home04 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Home04" */ '../../components/outline/Home04')
);
const Home05 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Home05" */ '../../components/outline/Home05')
);
const HomeLine = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-HomeLine" */ '../../components/outline/HomeLine')
);
const HomeSmile = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-HomeSmile" */ '../../components/outline/HomeSmile')
);
const HorizontalBarChart02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-HorizontalBarChart02" */ '../../components/outline/HorizontalBarChart02')
);
const InfoCircle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-InfoCircle" */ '../../components/outline/InfoCircle')
);
const Integer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Integer" */ '../../components/outline/Integer')
);
const IntersectCircle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-IntersectCircle" */ '../../components/outline/IntersectCircle')
);
const Json = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Json" */ '../../components/outline/JsonLanguage')
);
const Laptop02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Laptop02" */ '../../components/outline/Laptop02')
);
const LayersThree01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LayersThree01" */ '../../components/outline/LayersThree01')
);
const LayersThree02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LayersThree02" */ '../../components/outline/LayersThree02')
);
const LayoutAlt01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LayoutAlt01" */ '../../components/outline/LayoutAlt01')
);
const LayoutAlt04 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LayoutAlt04" */ '../../components/outline/LayoutAlt04')
);
const LayoutBottom = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LayoutBottom" */ '../../components/outline/LayoutBottom')
);
const LayoutLeft = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LayoutLeft" */ '../../components/outline/LayoutLeft')
);
const LayoutRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LayoutRight" */ '../../components/outline/LayoutRight')
);
const LayoutTop = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LayoutTop" */ '../../components/outline/LayoutTop')
);
const LcFileUpload = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LcFileUpload" */ '../../components/outline/LcFileUpload')
);
const LcForm = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LcForm" */ '../../components/outline/LcForm')
);
const LcSectionColumn = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LcSectionColumn" */ '../../components/outline/LcSectionColumn')
);
const LineChartUp01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LineChartUp01" */ '../../components/outline/LineChartUp01')
);
const LineLineChart = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LineLineChart" */ '../../components/outline/LineLineChart')
);
const LinkBroken01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LinkBroken01" */ '../../components/outline/LinkBroken01')
);
const Linkedin = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Linkedin" */ '../../components/colored/Linkedin')
);
const LinkExternal01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-LinkExternal01" */ '../../components/outline/LinkExternal01')
);
const List = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-List" */ '../../components/outline/List')
);
const Lock03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Lock03" */ '../../components/outline/Lock03')
);
const Logout01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Logout01" */ '../../components/outline/LogOut01')
);
const Loop = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Loop" */ '../../components/outline/Loop')
);
const Mail01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Mail01" */ '../../components/outline/Mail01')
);
const Mark = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Mark" */ '../../components/outline/Mark')
);
const Menu01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Menu01" */ '../../components/outline/Menu01')
);
const MessagePlusSquare = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-MessagePlusSquare" */ '../../components/outline/MessagePlusSquare')
);
const MessageSmileSquare = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-MessageSmileSquare" */ '../../components/outline/MessageSmileSquare')
);
const MessageTextSquare02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-MessageTextSquare02" */ '../../components/outline/MessageTextSquare02')
);
const Microphone01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Microphone01" */ '../../components/outline/Microphone01')
);
const Minus = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Minus" */ '../../components/outline/Minus')
);
const Monitor01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Monitor01" */ '../../components/outline/Monitor01')
);
const MultiDevice = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-MultiDevice" */ '../../components/outline/MultiDevice')
);
const NetworkGraph = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NetworkGraph" */ '../../components/outline/NetworkGraph')
);
const NoCodeAlert = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeAlert" */ '../../components/outline/no-code/NoCodeAlert')
);
const NoCodeAudioPlayer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeAudioPlayer" */ '../../components/outline/no-code/NoCodeAudioPlayer')
);
const NoCodeAvatar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeAvatar" */ '../../components/outline/no-code/NoCodeAvatar')
);
const NoCodeAvatarGroup = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeAvatarGroup" */ '../../components/outline/no-code/NoCodeAvatarGroup')
);
const NoCodeBottomsheet = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeBottomsheet" */ '../../components/outline/no-code/NoCodeBottomsheet')
);
const NoCodeBusinessHour = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeBusinessHour" */ '../../components/outline/no-code/NoCodeBusinessHour')
);
const NoCodeButton = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeButton" */ '../../components/outline/no-code/NoCodeButton')
);
const NoCodeButtonGroup = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeButtonGroup" */ '../../components/outline/no-code/NoCodeButtonGroup')
);
const NoCodeCalendar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeCalendar" */ '../../components/outline/no-code/NoCodeCalendar')
);
const NoCodeCamera = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeCamera" */ '../../components/outline/no-code/NoCodeCamera')
);
const NoCodeCard = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeCard" */ '../../components/outline/no-code/NoCodeCard')
);
const NoCodeCarousel = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeCarousel" */ '../../components/outline/no-code/NoCodeCarousel')
);
const NoCodeCategoryFilter = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeCategoryFilter" */ '../../components/outline/no-code/NoCodeCategoryFilter')
);
const NoCodeChart = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeChart" */ '../../components/outline/no-code/NoCodeChart')
);
const NoCodeCheckBox = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeCheckBox" */ '../../components/outline/no-code/NoCodeCheckBox')
);
const NoCodeCodeEditor = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeCodeEditor" */ '../../components/outline/no-code/NoCodeCodeEditor')
);
const NoCodeCollaboration = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeCollaboration" */ '../../components/outline/no-code/NoCodeCollaboration')
);
const NoCodeColorAlert = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorAlert" */ '../../components/colored/no-code/NoCodeColorAlert')
);
const NoCodeColorAudioPlayer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorAudioPlayer" */ '../../components/colored/no-code/NoCodeColorAudioPlayer')
);
const NoCodeColorAvatar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorAvatar" */ '../../components/colored/no-code/NoCodeColorAvatar')
);
const NoCodeColorAvatarGroup = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorAvatarGroup" */ '../../components/colored/no-code/NoCodeColorAvatarGroup')
);
const NoCodeColorBottomsheet = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorBottomsheet" */ '../../components/colored/no-code/NoCodeColorBottomsheet')
);
const NoCodeColorBusinessHour = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorBusinessHour" */ '../../components/colored/no-code/NoCodeColorBusinessHour')
);
const NoCodeColorButton = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorButton" */ '../../components/colored/no-code/NoCodeColorButton')
);
const NoCodeColorButtonGroup = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorButtonGroup" */ '../../components/colored/no-code/NoCodeColorButtonGroup')
);
const NoCodeColorCalendar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorCalendar" */ '../../components/colored/no-code/NoCodeColorCalendar')
);
const NoCodeColorCamera = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorCamera" */ '../../components/colored/no-code/NoCodeColorCamera')
);
const NoCodeColorCard = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorCard" */ '../../components/colored/no-code/NoCodeColorCard')
);
const NoCodeColorCarousel = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorCarousel" */ '../../components/colored/no-code/NoCodeColorCarousel')
);
const NoCodeColorCategoryFilter = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorCategoryFilter" */ '../../components/colored/no-code/NoCodeColorCategoryFilter')
);
const NoCodeColorChart = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorChart" */ '../../components/colored/no-code/NoCodeColorChart')
);
const NoCodeColorCodeEditor = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorCodeEditor" */ '../../components/colored/no-code/NoCodeColorCodeEditor')
);
const NoCodeColorCollaboration = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorCollaboration" */ '../../components/colored/no-code/NoCodeColorCollaboration')
);
const NoCodeColorComment = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorComment" */ '../../components/colored/no-code/NoCodeColorComment')
);
const NoCodeColorContainer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorContainer" */ '../../components/colored/no-code/NoCodeColorContainer')
);
const NoCodeColorContextualDialog = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorContextualDialog" */ '../../components/colored/no-code/NoCodeColorContextualDialog')
);
const NoCodeColorCopilot = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorCopilot" */ '../../components/colored/no-code/NoCodeColorCopilot')
);
const NoCodeColorDatePicker = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorDatePicker" */ '../../components/colored/no-code/NoCodeColorDatePicker')
);
const NoCodeColorDivider = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorDivider" */ '../../components/colored/no-code/NoCodeColorDivider')
);
const NoCodeColorEventsCalendar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorEventsCalendar" */ '../../components/colored/no-code/NoCodeColorEventsCalendar')
);
const NoCodeColorFileUpload = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorFileUpload" */ '../../components/colored/no-code/NoCodeColorFileUpload')
);
const NoCodeColorFilters = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorFilters" */ '../../components/colored/no-code/NoCodeColorFilters')
);
const NoCodeColorForm = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorForm" */ '../../components/colored/no-code/NoCodeColorForm')
);
const NoCodeColorIcon = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorIcon" */ '../../components/colored/no-code/NoCodeColorIcon')
);
const NoCodeColorIconButton = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorIconButton" */ '../../components/colored/no-code/NoCodeColorIconButton')
);
const NoCodeColorIframe = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorIframe" */ '../../components/colored/no-code/NoCodeColorIframe')
);
const NoCodeColorImage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorImage" */ '../../components/colored/no-code/NoCodeColorImage')
);
const NoCodeColorKeyValue = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorKeyValue" */ '../../components/colored/no-code/NoCodeColorKeyValue')
);
const NoCodeColorLink = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorLink" */ '../../components/colored/no-code/NoCodeColorLink')
);
const NoCodeColorLoader = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorLoader" */ '../../components/colored/no-code/NoCodeColorLoader')
);
const NoCodeColorMedia = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorMedia" */ '../../components/colored/no-code/NoCodeColorMedia')
);
const NoCodeColorMenu = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorMenu" */ '../../components/colored/no-code/NoCodeColorMenu')
);
const NoCodeColorMessageInput = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorMessageInput" */ '../../components/colored/no-code/NoCodeColorMessageInput')
);
const NoCodeColorModal = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorModal" */ '../../components/colored/no-code/NoCodeColorModal')
);
const NoCodeColorMultiStatCard = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorMultiStatCard" */ '../../components/colored/no-code/NoCodeColorMultiStatCard')
);
const NoCodeColorNavigation = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorNavigation" */ '../../components/colored/no-code/NoCodeColorNavigation')
);
const NoCodeColorNavigationContainer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorNavigationContainer" */ '../../components/colored/no-code/NoCodeColorNavigationContainer')
);
const NoCodeColorNestedTable = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorNestedTable" */ '../../components/colored/no-code/NoCodeColorNestedTable')
);
const NoCodeColorPdfViewer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorPdfViewer" */ '../../components/colored/no-code/NoCodeColorPdfViewer')
);
const NoCodeColorPressable = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorPressable" */ '../../components/colored/no-code/NoCodeColorPressable')
);
const NoCodeColorProgressBar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorProgressBar" */ '../../components/colored/no-code/NoCodeColorProgressBar')
);
const NoCodeColorQrCode = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorQrCode" */ '../../components/colored/no-code/NoCodeColorQrCode')
);
const NoCodeColorRepeatable = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorRepeatable" */ '../../components/colored/no-code/NoCodeColorRepeatable')
);
const NoCodeColorRepeatableList = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorRepeatableList" */ '../../components/colored/no-code/NoCodeColorRepeatableList')
);
const NoCodeColorRichtext = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorRichtext" */ '../../components/colored/no-code/NoCodeColorRichtext')
);
const NoCodeColorScanner = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorScanner" */ '../../components/colored/no-code/NoCodeColorScanner')
);
const NoCodeColorSelect = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorSelect" */ '../../components/colored/no-code/NoCodeColorSelect')
);
const NoCodeColorSideDrawer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorSideDrawer" */ '../../components/colored/no-code/NoCodeColorSideDrawer')
);
const NoCodeColorStack = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorStack" */ '../../components/colored/no-code/NoCodeColorStack')
);
const NoCodeColorStatCard = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorStatCard" */ '../../components/colored/no-code/NoCodeColorStatCard')
);
const NoCodeColorStatus = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorStatus" */ '../../components/colored/no-code/NoCodeColorStatus')
);
const NoCodeColorSteppedContainer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorSteppedContainer" */ '../../components/colored/no-code/NoCodeColorSteppedContainer')
);
const NoCodeColorStepper = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorStepper" */ '../../components/colored/no-code/NoCodeColorStepper')
);
const NoCodeColorSwipable = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorSwipable" */ '../../components/colored/no-code/NoCodeColorSwipable')
);
const NoCodeColorTable = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorTable" */ '../../components/colored/no-code/NoCodeColorTable')
);
const NoCodeColorTabs = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorTabs" */ '../../components/colored/no-code/NoCodeColorTabs')
);
const NoCodeColorTag = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorTag" */ '../../components/colored/no-code/NoCodeColorTag')
);
const NoCodeColorText = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorText" */ '../../components/colored/no-code/NoCodeColorText')
);
const NoCodeColorTextInput = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorTextInput" */ '../../components/colored/no-code/NoCodeColorTextInput')
);
const NoCodeColorTimeline = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorTimeline" */ '../../components/colored/no-code/NoCodeColorTimeline')
);
const NoCodeColorTimer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorTimer" */ '../../components/colored/no-code/NoCodeColorTimer')
);
const NoCodeColorVideo = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColorVideo" */ '../../components/colored/no-code/NoCodeColorVideo')
);
const NoCodeColumns3 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColumns3" */ '../../components/outline/no-code/NoCodeColumns3')
);
const NoCodeColumns4 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColumns4" */ '../../components/outline/no-code/NoCodeColumns4')
);
const NoCodeColumns5 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColumns5" */ '../../components/outline/no-code/NoCodeColumns5')
);
const NoCodeColumns6 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeColumns6" */ '../../components/outline/no-code/NoCodeColumns6')
);
const NoCodeContainer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContainer" */ '../../components/outline/no-code/NoCodeContainer')
);
const NoCodeContainer11 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContainer11" */ '../../components/outline/no-code/NoCodeContainer11')
);
const NoCodeContainer112 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContainer112" */ '../../components/outline/no-code/NoCodeContainer112')
);
const NoCodeContainer12 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContainer12" */ '../../components/outline/no-code/NoCodeContainer12')
);
const NoCodeContainer121 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContainer121" */ '../../components/outline/no-code/NoCodeContainer121')
);
const NoCodeContainer13 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContainer13" */ '../../components/outline/no-code/NoCodeContainer13')
);
const NoCodeContainer21 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContainer21" */ '../../components/outline/no-code/NoCodeContainer21')
);
const NoCodeContainer211 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContainer211" */ '../../components/outline/no-code/NoCodeContainer211')
);
const NoCodeContainer23 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContainer23" */ '../../components/outline/no-code/NoCodeContainer23')
);
const NoCodeContainer31 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContainer31" */ '../../components/outline/no-code/NoCodeContainer31')
);
const NoCodeContainer32 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContainer32" */ '../../components/outline/no-code/NoCodeContainer32')
);
const NoCodeContextualDialog = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeContextualDialog" */ '../../components/outline/no-code/NoCodeContextualDialog')
);
const NoCodeCopilot = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeCopilot" */ '../../components/outline/no-code/NoCodeCopilot')
);
const NoCodeDatePicker = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeDatePicker" */ '../../components/outline/no-code/NoCodeDatePicker')
);
const NoCodeDivider = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeDivider" */ '../../components/outline/no-code/NoCodeDivider')
);
const NoCodeEventsCalendar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeEventsCalendar" */ '../../components/outline/no-code/NoCodeEventsCalendar')
);
const NoCodeFileUpload = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeFileUpload" */ '../../components/outline/no-code/NoCodeFileUpload')
);
const NoCodeFilters = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeFilters" */ '../../components/outline/no-code/NoCodeFilters')
);
const NoCodeForm = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeForm" */ '../../components/outline/no-code/NoCodeForm')
);
const NoCodeHeatMap = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeHeatMap" */ '../../components/outline/no-code/NoCodeHeatMap')
);
const NoCodeIcon = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeIcon" */ '../../components/outline/no-code/NoCodeIcon')
);
const NoCodeIconButton = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeIconButton" */ '../../components/outline/no-code/NoCodeIconButton')
);
const NoCodeIframe = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeIframe" */ '../../components/outline/no-code/NoCodeIframe')
);
const NoCodeImage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeImage" */ '../../components/outline/no-code/NoCodeImage')
);
const NoCodeKeyValue = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeKeyValue" */ '../../components/outline/no-code/NoCodeKeyValue')
);
const NoCodeLink = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeLink" */ '../../components/outline/no-code/NoCodeLink')
);
const NoCodeLoader = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeLoader" */ '../../components/outline/no-code/NoCodeLoader')
);
const NoCodeMedia = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeMedia" */ '../../components/outline/no-code/NoCodeMedia')
);
const NoCodeMenu = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeMenu" */ '../../components/outline/no-code/NoCodeMenu')
);
const NoCodeMessageInput = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeMessageInput" */ '../../components/outline/no-code/NoCodeMessageInput')
);
const NoCodeModal = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeModal" */ '../../components/outline/no-code/NoCodeModal')
);
const NoCodeMultiStatCard = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeMultiStatCard" */ '../../components/outline/no-code/NoCodeMultiStatCard')
);
const NoCodeNavigation = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeNavigation" */ '../../components/outline/no-code/NoCodeNavigation')
);
const NoCodeNavigationContainer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeNavigationContainer" */ '../../components/outline/no-code/NoCodeNavigationContainer')
);
const NoCodeNestedTable = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeNestedTable" */ '../../components/outline/no-code/NoCodeNestedTable')
);
const NoCodePdfViewer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodePdfViewer" */ '../../components/outline/no-code/NoCodePdfViewer')
);
const NoCodePinnedRightPane = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodePinnedRightPane" */ '../../components/outline/no-code/NoCodePinnedRightPane')
);
const NoCodeProgressBar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeProgressBar" */ '../../components/outline/no-code/NoCodeProgressBar')
);
const NoCodeQrCode = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeQrCode" */ '../../components/outline/no-code/NoCodeQrCode')
);
const NoCodeRepeatable = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeRepeatable" */ '../../components/outline/no-code/NoCodeRepeatable')
);
const NoCodeRepeatableList = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeRepeatableList" */ '../../components/outline/no-code/NoCodeRepeatableList')
);
const NoCodeRichtext = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeRichtext" */ '../../components/outline/no-code/NoCodeRichtext')
);
const NoCodeScanner = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeScanner" */ '../../components/outline/no-code/NoCodeScanner')
);
const NoCodeSideDrawer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeSideDrawer" */ '../../components/outline/no-code/NoCodeSideDrawer')
);
const NoCodeStack = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeStack" */ '../../components/outline/no-code/NoCodeStack')
);
const NoCodeStatCard = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeStatCard" */ '../../components/outline/no-code/NoCodeStatCard')
);
const NoCodeSteppedContainer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeSteppedContainer" */ '../../components/outline/no-code/NoCodeSteppedContainer')
);
const NoCodeStepper = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeStepper" */ '../../components/outline/no-code/NoCodeStepper')
);
const NoCodeTable = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeTable" */ '../../components/outline/no-code/NoCodeTable')
);
const NoCodeTabs = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeTabs" */ '../../components/outline/no-code/NoCodeTabs')
);
const NoCodeTag = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeTag" */ '../../components/outline/no-code/NoCodeTag')
);
const NoCodeText = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeText" */ '../../components/outline/no-code/NoCodeText')
);
const NoCodeTextInput = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeTextInput" */ '../../components/outline/no-code/NoCodeTextInput')
);
const NoCodeTimeline = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeTimeline" */ '../../components/outline/no-code/NoCodeTimeline')
);
const NoCodeTimer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeTimer" */ '../../components/outline/no-code/NoCodeTimer')
);
const NoCodeToggle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeToggle" */ '../../components/outline/no-code/NoCodeToggle')
);
const NoCodeVideo = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoCodeVideo" */ '../../components/outline/no-code/NoCodeVideo')
);
const NoEntry = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-NoEntry" */ '../../components/colored/NoEntry')
);
const OpenSourceModel = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-OpenSourceModel" */ '../../components/colored/OpenSourceModel')
);
const PackageCheck = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-PackageCheck" */ '../../components/outline/PackageCheck')
);
const Paginate = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Paginate" */ '../../components/outline/Paginate')
);
const Palette = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Palette" */ '../../components/outline/Palette')
);
const Pause = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Pause" */ '../../components/outline/Pause')
);
const Pdf2 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Pdf2" */ '../../components/colored/Pdf2')
);
const Phone02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Phone02" */ '../../components/outline/Phone02')
);
const PieChart01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-PieChart01" */ '../../components/outline/PieChart01')
);
const Play = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Play" */ '../../components/outline/Play')
);
const PlayCircle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-PlayCircle" */ '../../components/outline/PlayCircle')
);
const Plus = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Plus" */ '../../components/outline/Plus')
);
const Ppt = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Ppt" */ '../../components/colored/Ppt')
);
const Pptx = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Pptx" */ '../../components/colored/Pptx')
);
const Prohibition = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Prohibition" */ '../../components/colored/Prohibition')
);
const QuoteEnd = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-QuoteEnd" */ '../../components/outline/QuoteEnd')
);
const RadarSpiderChart = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-RadarSpiderChart" */ '../../components/outline/RadarSpiderChart')
);
const RadialBarChart = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-RadialBarChart" */ '../../components/outline/RadialBarChart')
);
const RadialColumnChart = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-RadialColumnChart" */ '../../components/outline/RadialColumnChart')
);
const RadialScatterChart = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-RadialScatterChart" */ '../../components/outline/RadialScatterChart')
);
const RefreshCcw01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-RefreshCcw01" */ '../../components/outline/RefreshCcw01')
);
const RefreshCcw02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-RefreshCcw02" */ '../../components/outline/RefreshCcw02')
);
const RefreshCcw05 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-RefreshCcw05" */ '../../components/outline/RefreshCcw05')
);
const RefreshCw01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-RefreshCw01" */ '../../components/outline/RefreshCw01')
);
const Reply = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Reply" */ '../../components/outline/Reply')
);
const RichText = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-RichText" */ '../../components/outline/RichText')
);
const Route = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Route" */ '../../components/outline/Route')
);
const SankeyChart01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SankeyChart01" */ '../../components/outline/SankeyChart01')
);
const SchemaMapping = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SchemaMapping" */ '../../components/outline/SchemaMapping')
);
const Scissors01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Scissors01" */ '../../components/outline/Scissors01')
);
const Server04 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Server04" */ '../../components/outline/Server04')
);
const SessionStorage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SessionStorage" */ '../../components/outline/SessionStorage')
);
const Settings01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Settings01" */ '../../components/outline/Settings01')
);
const Settings04 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Settings04" */ '../../components/outline/Settings04')
);
const Settings05 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Settings05" */ '../../components/outline/Settings05')
);
const Share04 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Share04" */ '../../components/outline/Share04')
);
const ShieldLock = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ShieldLock" */ '../../components/outline/ShieldLock')
);
const SlashCircle01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SlashCircle01" */ '../../components/outline/SlashCircle01')
);
const SquareFilled = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SquareFilled" */ '../../components/solid/SquareFilled')
);
const Star01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Star01" */ '../../components/outline/Star01')
);
const Stars02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Stars02" */ '../../components/outline/Stars02')
);
const SvgActivity = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgActivity" */ '../../components/outline/Activity')
);
const SvgAep = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAep" */ '../../components/colored/Aep')
);
const SvgAi = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAi" */ '../../components/colored/Ai')
);
const SvgAiAgent = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAiAgent" */ '../../components/outline/AiAgent')
);
const SvgAiTeam = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAiTeam" */ '../../components/outline/AiTeam')
);
const SvgAlignHorizontalCenter = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignHorizontalCenter" */ '../../components/outline/AlignHorizontalCenter')
);
const SvgAlignHorizontalCentre02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignHorizontalCentre02" */ '../../components/outline/AlignHorizontalCentre02')
);
const SvgAlignHorizontalEnd = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignHorizontalEnd" */ '../../components/outline/AlignHorizontalEnd')
);
const SvgAlignHorizontalSpaceBetween = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignHorizontalSpaceBetween" */ '../../components/outline/AlignHorizontalSpaceBetween')
);
const SvgAlignHorizontalStart = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignHorizontalStart" */ '../../components/outline/AlignHorizontalStart')
);
const SvgAlignHorizontalStretch = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignHorizontalStretch" */ '../../components/outline/AlignHorizontalStretch')
);
const SvgAlignLeft02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignLeft02" */ '../../components/outline/AlignLeft02')
);
const SvgAlignVerticalCenter = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignVerticalCenter" */ '../../components/outline/AlignVerticalCenter')
);
const SvgAlignVerticalEnd = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignVerticalEnd" */ '../../components/outline/AlignVerticalEnd')
);
const SvgAlignVerticalSpaceBetween = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignVerticalSpaceBetween" */ '../../components/outline/AlignVerticalSpaceBetween')
);
const SvgAlignVerticalStart = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignVerticalStart" */ '../../components/outline/AlignVerticalStart')
);
const SvgAlignVerticalStretch = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAlignVerticalStretch" */ '../../components/outline/AlignVerticalStretch')
);
const SvgAnnotationAlert = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAnnotationAlert" */ '../../components/outline/AnnotationAlert')
);
const SvgArrowNarrowDownLeft = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgArrowNarrowDownLeft" */ '../../components/outline/ArrowNarrowDownLeft')
);
const SvgArrowNarrowUp = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgArrowNarrowUp" */ '../../components/outline/ArrowNarrowUp')
);
const SvgArrowNarrowUpRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgArrowNarrowUpRight" */ '../../components/outline/ArrowNarrowUpRight')
);
const SvgArrowUpRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgArrowUpRight" */ '../../components/outline/ArrowUpRight')
);
const SvgAttachment01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAttachment01" */ '../../components/outline/Attachment01')
);
const SvgAudience = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAudience" */ '../../components/outline/Audience')
);
const SvgAudio = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAudio" */ '../../components/colored/Audio')
);
const SvgAvi = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAvi" */ '../../components/colored/Avi')
);
const SvgAward01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAward01" */ '../../components/outline/Award01')
);
const SvgAward05 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAward05" */ '../../components/outline/Award05')
);
const SvgAzure = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgAzure" */ '../../components/colored/Azure')
);
const SvgBankNote01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgBankNote01" */ '../../components/outline/BankNote01')
);
const SvgBankNote02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgBankNote02" */ '../../components/outline/BankNote02')
);
const SvgBike01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgBike01" */ '../../components/outline/Bike01')
);
const SvgBookClosed = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgBookClosed" */ '../../components/outline/BookClosed')
);
const SvgBookOpen01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgBookOpen01" */ '../../components/outline/BookOpen01')
);
const SvgBracketsX = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgBracketsX" */ '../../components/outline/BracketsX')
);
const SvgCalculator = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCalculator" */ '../../components/outline/Calculator')
);
const SvgCalculator02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCalculator02" */ '../../components/outline/Calculator02')
);
const SvgCalendar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCalendar" */ '../../components/outline/Calendar')
);
const SvgCalendarClock = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCalendarClock" */ '../../components/outline/CalendarClock')
);
const SvgCar02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCar02" */ '../../components/outline/Car02')
);
const SvgCatalog = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCatalog" */ '../../components/outline/Catalog')
);
const SvgCertificate02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCertificate02" */ '../../components/outline/Certificate02')
);
const SvgChartBreakoutCircle1 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgChartBreakoutCircle1" */ '../../components/outline/ChartBreakoutCircle1')
);
const SvgChatView = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgChatView" */ '../../components/outline/ChatView')
);
const SvgCheck = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCheck" */ '../../components/outline/Check')
);
const SvgCheckCircle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCheckCircle" */ '../../components/outline/CheckCircle')
);
const SvgCheckSquare = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCheckSquare" */ '../../components/outline/CheckSquare')
);
const SvgCheckVerified02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCheckVerified02" */ '../../components/outline/CheckVerified02')
);
const SvgClipboardCheck = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgClipboardCheck" */ '../../components/outline/ClipboardCheck')
);
const SvgClock = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgClock" */ '../../components/outline/Clock')
);
const SvgClockCheck = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgClockCheck" */ '../../components/outline/ClockCheck')
);
const SvgClockFastForward = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgClockFastForward" */ '../../components/outline/ClockFastForward')
);
const SvgClockRewind = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgClockRewind" */ '../../components/outline/ClockRewind')
);
const SvgCode = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCode" */ '../../components/colored/Code')
);
const SvgCodeBrowser = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCodeBrowser" */ '../../components/outline/CodeBrowser')
);
const SvgCodeCircle01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCodeCircle01" */ '../../components/outline/CodeCircle01')
);
const SvgColumns03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgColumns03" */ '../../components/outline/Columns03')
);
const SvgCornerDownLeft = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCornerDownLeft" */ '../../components/outline/CornerDownLeft')
);
const SvgCreditCardLock = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCreditCardLock" */ '../../components/outline/CreditCardLock')
);
const SvgCreditCardMinus = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCreditCardMinus" */ '../../components/outline/CreditCardMinus')
);
const SvgCreditCardPlus = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCreditCardPlus" */ '../../components/outline/CreditCardPlus')
);
const SvgCryptocurrency01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCryptocurrency01" */ '../../components/outline/Cryptocurrency01')
);
const SvgCss = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCss" */ '../../components/colored/Css')
);
const SvgCsv = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCsv" */ '../../components/colored/Csv')
);
const SvgCurrencyDollar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCurrencyDollar" */ '../../components/outline/CurrencyDollar')
);
const SvgCurrencyDollarCircle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCurrencyDollarCircle" */ '../../components/outline/CurrencyDollarCircle')
);
const SvgCurrencyEuro = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCurrencyEuro" */ '../../components/outline/CurrencyEuro')
);
const SvgCurrencyPound = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCurrencyPound" */ '../../components/outline/CurrencyPound')
);
const SvgCurrencyRuble = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCurrencyRuble" */ '../../components/outline/CurrencyRuble')
);
const SvgCurrencyRupee = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCurrencyRupee" */ '../../components/outline/CurrencyRupee')
);
const SvgCurrencyYen = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgCurrencyYen" */ '../../components/outline/CurrencyYen')
);
const SvgData = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgData" */ '../../components/outline/Data')
);
const SvgDatabase02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgDatabase02" */ '../../components/outline/Database02')
);
const SvgDatabase03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgDatabase03" */ '../../components/outline/Database03')
);
const SvgDataflow01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgDataflow01" */ '../../components/outline/Dataflow01')
);
const SvgDetokenisation = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgDetokenisation" */ '../../components/outline/Detokenisation')
);
const SvgDmg = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgDmg" */ '../../components/colored/Dmg')
);
const SvgDoc = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgDoc" */ '../../components/colored/Doc')
);
const SvgDocument = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgDocument" */ '../../components/colored/Document')
);
const SvgDocx = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgDocx" */ '../../components/colored/Docx')
);
const SvgDot = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgDot" */ '../../components/solid/Dot')
);
const SvgDownload01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgDownload01" */ '../../components/outline/Download01')
);
const SvgDownloadCloud02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgDownloadCloud02" */ '../../components/outline/DownloadCloud02')
);
const SvgEdit03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgEdit03" */ '../../components/outline/Edit03')
);
const SvgEps = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgEps" */ '../../components/colored/Eps')
);
const SvgEpubs = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgEpubs" */ '../../components/colored/Epubs')
);
const SvgEraser = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgEraser" */ '../../components/outline/Eraser')
);
const SvgExe = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgExe" */ '../../components/colored/Exe')
);
const SvgExpand03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgExpand03" */ '../../components/outline/Expand03')
);
const SvgEye = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgEye" */ '../../components/outline/Eye')
);
const SvgEyeOff = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgEyeOff" */ '../../components/outline/EyeOff')
);
const SvgFaceId = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFaceId" */ '../../components/outline/FaceId')
);
const SvgFig = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFig" */ '../../components/colored/Fig')
);
const SvgFile02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFile02" */ '../../components/outline/File02')
);
const SvgFileCheck02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFileCheck02" */ '../../components/outline/FileCheck02')
);
const SvgFileCheck03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFileCheck03" */ '../../components/outline/FileCheck03')
);
const SvgFileCode01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFileCode01" */ '../../components/outline/FileCode01')
);
const SvgFileLock02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFileLock02" */ '../../components/outline/FileLock02')
);
const SvgFileSearch02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFileSearch02" */ '../../components/outline/FileSearch02')
);
const SvgFingerprint04 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFingerprint04" */ '../../components/outline/Fingerprint04')
);
const SvgFolder = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFolder" */ '../../components/colored/Folder')
);
const SvgFolder02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFolder02" */ '../../components/outline/Folder02')
);
const SvgFolderPlus = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFolderPlus" */ '../../components/outline/FolderPlus')
);
const SvgFolderQuestion = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFolderQuestion" */ '../../components/outline/FolderQuestion')
);
const SvgFolderX = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFolderX" */ '../../components/outline/FolderX')
);
const SvgFunction = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgFunction" */ '../../components/outline/Function')
);
const SvgGif = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgGif" */ '../../components/colored/Gif')
);
const SvgGoogle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgGoogle" */ '../../components/colored/Google')
);
const SvgGoogleMeet = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgGoogleMeet" */ '../../components/colored/GoogleMeet')
);
const SvgGrid01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgGrid01" */ '../../components/outline/Grid01')
);
const SvgGridPlus = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgGridPlus" */ '../../components/outline/GridPlus')
);
const SvgGroovyLanguage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgGroovyLanguage" */ '../../components/outline/GroovyLanguage')
);
const SvgHanger = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgHanger" */ '../../components/outline/Hanger')
);
const SvgHighlighter = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgHighlighter" */ '../../components/outline/Highlighter')
);
const SvgHtml = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgHtml" */ '../../components/colored/Html')
);
const SvgHubspot = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgHubspot" */ '../../components/colored/Hubspot')
);
const SvgImage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgImage" */ '../../components/colored/Image')
);
const SvgImg = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgImg" */ '../../components/colored/Img')
);
const SvgIndd = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgIndd" */ '../../components/colored/Indd')
);
const SvgInfoSquare = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgInfoSquare" */ '../../components/outline/InfoSquare')
);
const SvgJava = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgJava" */ '../../components/colored/Java')
);
const SvgJavaLanguage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgJavaLanguage" */ '../../components/outline/JavaLanguage')
);
const SvgJpeg = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgJpeg" */ '../../components/colored/Jpeg')
);
const SvgJpg = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgJpg" */ '../../components/colored/Jpg')
);
const SvgJs = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgJs" */ '../../components/colored/Js')
);
const SvgJsLanguage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgJsLanguage" */ '../../components/outline/JsLanguage')
);
const SvgJson = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgJson" */ '../../components/colored/Json')
);
const SvgJsonLanguage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgJsonLanguage" */ '../../components/outline/JsonLanguage')
);
const SvgJsonSchemaLanguage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgJsonSchemaLanguage" */ '../../components/outline/JsonSchemaLanguage')
);
const SvgJwtValidation = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgJwtValidation" */ '../../components/outline/JwtValidation')
);
const SvgKey01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgKey01" */ '../../components/outline/Key01')
);
const SvgLayoutGrid02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLayoutGrid02" */ '../../components/outline/LayoutGrid02')
);
const SvgLayoutTop = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLayoutTop" */ '../../components/outline/LayoutTop')
);
const SvgLcIcon = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLcIcon" */ '../../components/outline/LcIcon')
);
const SvgLcIconButton = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLcIconButton" */ '../../components/outline/LcIconButton')
);
const SvgLcLink = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLcLink" */ '../../components/outline/LcLink')
);
const SvgLcProgressBar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLcProgressBar" */ '../../components/outline/LcProgressBar')
);
const SvgLcTimeline = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLcTimeline" */ '../../components/outline/LcTimeline')
);
const SvgLdap = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLdap" */ '../../components/colored/Ldap')
);
const SvgLightbulb02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLightbulb02" */ '../../components/outline/Lightbulb02')
);
const SvgLightbulb05 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLightbulb05" */ '../../components/outline/Lightbulb05')
);
const SvgLineChartUp03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLineChartUp03" */ '../../components/outline/LineChartUp03')
);
const SvgLink01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLink01" */ '../../components/outline/Link01')
);
const SvgLocation = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLocation" */ '../../components/outline/Location')
);
const SvgLock01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLock01" */ '../../components/outline/Lock01')
);
const SvgLoop = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgLoop" */ '../../components/outline/Loop')
);
const SvgMarkerPin01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMarkerPin01" */ '../../components/outline/MarkerPin01')
);
const SvgMedicalCross = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMedicalCross" */ '../../components/outline/MedicalCross')
);
const SvgMessageChatSquare = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMessageChatSquare" */ '../../components/outline/MessageChatSquare')
);
const SvgMessageHeartSquare = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMessageHeartSquare" */ '../../components/outline/MessageHeartSquare')
);
const SvgMessageSquare02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMessageSquare02" */ '../../components/outline/MessageSquare02')
);
const SvgMessageTextSquare01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMessageTextSquare01" */ '../../components/outline/MessageTextSquare01')
);
const SvgMicrosoft = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMicrosoft" */ '../../components/colored/Microsoft')
);
const SvgMicrosoftTeams = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMicrosoftTeams" */ '../../components/colored/MicrosoftTeams')
);
const SvgMp3 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMp3" */ '../../components/colored/Mp3')
);
const SvgMp4 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMp4" */ '../../components/colored/Mp4')
);
const SvgMpeg = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMpeg" */ '../../components/colored/Mpeg')
);
const SvgMultiSelect = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgMultiSelect" */ '../../components/outline/MultiSelect')
);
const SvgNoCodeBottomsheet = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgNoCodeBottomsheet" */ '../../components/outline/no-code/NoCodeBottomsheet')
);
const SvgNoCodeCascader = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgNoCodeCascader" */ '../../components/outline/no-code/NoCodeCascader')
);
const SvgNoCodeColorCascader = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgNoCodeColorCascader" */ '../../components/colored/no-code/NoCodeColorCascader')
);
const SvgNoCodeColorCheckbox = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgNoCodeColorCheckbox" */ '../../components/colored/no-code/NoCodeColorCheckbox')
);
const SvgNoCodeColorImageGrid = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgNoCodeColorImageGrid" */ '../../components/colored/no-code/NoCodeColorImageGrid')
);
const SvgNoCodeColorToggle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgNoCodeColorToggle" */ '../../components/colored/no-code/NoCodeColorToggle')
);
const SvgNoCodeForm = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgNoCodeForm" */ '../../components/outline/no-code/NoCodeForm')
);
const SvgNoCodeImageGrid = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgNoCodeImageGrid" */ '../../components/outline/no-code/NoCodeImageGrid')
);
const SvgNoCodeSideDrawer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgNoCodeSideDrawer" */ '../../components/outline/no-code/NoCodeSideDrawer')
);
const SvgNotification = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgNotification" */ '../../components/outline/Bell01')
);
const SvgNotificationText = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgNotificationText" */ '../../components/outline/NotificationText')
);
const SvgOkta = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgOkta" */ '../../components/colored/Okta')
);
const SvgOkta02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgOkta02" */ '../../components/colored/Okta02')
);
const SvgOpenId = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgOpenId" */ '../../components/colored/OpenId')
);
const SvgOtel = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgOtel" */ '../../components/solid/Otel')
);
const SvgOutlineFolder = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgOutlineFolder" */ '../../components/outline/Folder')
);
const SvgPackage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPackage" */ '../../components/outline/Package')
);
const SvgPage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPage" */ '../../components/outline/File04')
);
const SvgPageVariables = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPageVariables" */ '../../components/outline/PageVariables')
);
const SvgPaintPour = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPaintPour" */ '../../components/outline/PaintPour')
);
const SvgPaperAirplane = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPaperAirplane" */ '../../components/outline/PaperAirplane')
);
const SvgPasscode = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPasscode" */ '../../components/outline/Passcode')
);
const SvgPasscodeLock = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPasscodeLock" */ '../../components/outline/PasscodeLock')
);
const SvgPdf = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPdf" */ '../../components/colored/Pdf')
);
const SvgPencil01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPencil01" */ '../../components/outline/Pencil01')
);
const SvgPeople = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPeople" */ '../../components/outline/People')
);
const SvgPercent02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPercent02" */ '../../components/outline/Percent02')
);
const SvgPhone = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPhone" */ '../../components/outline/Phone')
);
const SvgPhone01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPhone01" */ '../../components/outline/Phone01')
);
const SvgPhone02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPhone02" */ '../../components/outline/Phone02')
);
const SvgPipeline01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPipeline01" */ '../../components/outline/Pipelines01')
);
const SvgPlayCircle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPlayCircle" */ '../../components/outline/PlayCircle')
);
const SvgPng = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPng" */ '../../components/colored/Png')
);
const SvgPpt = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPpt" */ '../../components/colored/Ppt')
);
const SvgPptx = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPptx" */ '../../components/colored/Pptx')
);
const SvgPsd = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPsd" */ '../../components/colored/Psd')
);
const SvgPuzzlePiece02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPuzzlePiece02" */ '../../components/outline/PuzzlePiece02')
);
const SvgPythonLanguage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgPythonLanguage" */ '../../components/outline/PythonLanguage')
);
const SvgQuotes = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgQuotes" */ '../../components/outline/QuoteStart')
);
const SvgRadioSelect = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgRadioSelect" */ '../../components/outline/RadioSelect')
);
const SvgRar = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgRar" */ '../../components/colored/Rar')
);
const SvgRequestTransformer = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgRequestTransformer" */ '../../components/outline/RequestTransformer')
);
const SvgResetPassword = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgResetPassword" */ '../../components/outline/ResetPassword')
);
const SvgReverseLeft = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgReverseLeft" */ '../../components/outline/ReverseLeft')
);
const SvgRocket02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgRocket02" */ '../../components/outline/Rocket02')
);
const SvgRows01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgRows01" */ '../../components/outline/Rows01')
);
const SvgRss = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgRss" */ '../../components/colored/Rss')
);
const SvgSalesforce = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSalesforce" */ '../../components/colored/Salesforce')
);
const SvgSearchMd = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSearchMd" */ '../../components/outline/SearchMd')
);
const SvgSearchRefraction = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSearchRefraction" */ '../../components/outline/SearchRefraction')
);
const SvgSearchStar02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSearchStar02" */ '../../components/solid/SearchStar02')
);
const SvgSettings01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSettings01" */ '../../components/outline/Settings01')
);
const SvgShare07 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgShare07" */ '../../components/outline/Share07')
);
const SvgShield02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgShield02" */ '../../components/outline/Shield02')
);
const SvgShield03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgShield03" */ '../../components/outline/Shield03')
);
const SvgShieldTick = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgShieldTick" */ '../../components/outline/ShieldTick')
);
const SvgShoppingBag02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgShoppingBag02" */ '../../components/outline/ShoppingBag02')
);
const SvgShuffle01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgShuffle01" */ '../../components/outline/Shuffle01')
);
const SvgSignal01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSignal01" */ '../../components/outline/Signal01')
);
const SvgSignal02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSignal02" */ '../../components/outline/Signal02')
);
const SvgSignal03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSignal03" */ '../../components/outline/Signal03')
);
const SvgSimcard = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSimcard" */ '../../components/outline/Simcard')
);
const SvgSingleSelect = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSingleSelect" */ '../../components/outline/SingleSelect')
);
const SvgSlack = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSlack" */ '../../components/colored/Slack')
);
const SvgSliders04 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSliders04" */ '../../components/outline/Sliders04')
);
const SvgSpeedometer01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSpeedometer01" */ '../../components/outline/Speedometer01')
);
const SvgSpeedometer03 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSpeedometer03" */ '../../components/outline/Speedometer03')
);
const SvgSpreadsheet = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSpreadsheet" */ '../../components/colored/Spreadsheet')
);
const SvgSprinklr = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSprinklr" */ '../../components/colored/Sprinklr')
);
const SvgSql = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSql" */ '../../components/colored/Sql')
);
const SvgStar02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgStar02" */ '../../components/outline/Star02')
);
const SvgStar04 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgStar04" */ '../../components/outline/Star04')
);
const SvgStar07 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgStar07" */ '../../components/outline/Star07')
);
const SvgStepComplete = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgStepComplete" */ '../../components/colored/StepComplete')
);
const SvgStepCurrent = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgStepCurrent" */ '../../components/colored/StepCurrent')
);
const SvgStepError = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgStepError" */ '../../components/colored/StepError')
);
const SvgStepIncomplete = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgStepIncomplete" */ '../../components/outline/StepIncomplete')
);
const SvgStore = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgStore" */ '../../components/outline/Store')
);
const SvgSupport = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSupport" */ '../../components/outline/Support')
);
const SvgSvg = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSvg" */ '../../components/colored/Svg')
);
const SvgSwitchOff = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSwitchOff" */ '../../components/outline/SwitchOff')
);
const SvgSwitchOn = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgSwitchOn" */ '../../components/outline/SwitchOn')
);
const SvgTablet01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTablet01" */ '../../components/outline/Tablet01')
);
const SvgTabletHorizontal = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTabletHorizontal" */ '../../components/outline/TabletHorizontal')
);
const SvgTag01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTag01" */ '../../components/outline/Tag01')
);
const SvgTarget = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTarget" */ '../../components/outline/Target')
);
const SvgTelescope = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTelescope" */ '../../components/outline/Telescope')
);
const SvgTerminalBrowser = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTerminalBrowser" */ '../../components/outline/TerminalBrowser')
);
const SvgTextInput = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTextInput" */ '../../components/outline/TextInput')
);
const SvgTiff = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTiff" */ '../../components/colored/Tiff')
);
const SvgTool01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTool01" */ '../../components/outline/Tool01')
);
const SvgTrain = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTrain" */ '../../components/outline/Train')
);
const SvgTranslate02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTranslate02" */ '../../components/outline/Translate02')
);
const SvgTrash01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTrash01" */ '../../components/outline/Trash01')
);
const SvgTxt = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgTxt" */ '../../components/colored/Txt')
);
const SvgUnifyAi = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgUnifyAi" */ '../../components/outline/no-code/UnifyAi')
);
const SvgUnifyApi = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgUnifyApi" */ '../../components/outline/UnifyApi')
);
const SvgUpload01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgUpload01" */ '../../components/outline/Upload01')
);
const SvgUploadCloud02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgUploadCloud02" */ '../../components/outline/UploadCloud02')
);
const SvgUserCheck01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgUserCheck01" */ '../../components/outline/UserCheck01')
);
const SvgUserPlus01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgUserPlus01" */ '../../components/outline/UserPlus01')
);
const SvgUserRight01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgUserRight01" */ '../../components/outline/UserRight01')
);
const SvgUsers01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgUsers01" */ '../../components/outline/Users01')
);
const SvgUsersCheck = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgUsersCheck" */ '../../components/outline/UsersCheck')
);
const SvgUsersRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgUsersRight" */ '../../components/outline/UsersRight')
);
const SvgUsersX = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgUsersX" */ '../../components/outline/UsersX')
);
const SvgVariable = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgVariable" */ '../../components/outline/Variable')
);
const SvgVideo01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgVideo01" */ '../../components/colored/Video01')
);
const SvgWav = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgWav" */ '../../components/colored/Wav')
);
const SvgWebp = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgWebp" */ '../../components/colored/Webp')
);
const SvgWhatsapp = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgWhatsapp" */ '../../components/colored/Whatsapp')
);
const SvgXClose = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgXClose" */ '../../components/outline/XClose')
);
const SvgXLogo = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgXLogo" */ '../../components/outline/XLogo')
);
const SvgXls = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgXls" */ '../../components/colored/Xls')
);
const SvgXml = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgXml" */ '../../components/colored/Xml')
);
const SvgXmlLanguage = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgXmlLanguage" */ '../../components/outline/XmlLanguage')
);
const SvgZapOff = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgZapOff" */ '../../components/outline/ZapOff')
);
const SvgZip = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgZip" */ '../../components/colored/Zip')
);
const SvgZoom = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgZoom" */ '../../components/colored/Zoom')
);
const SvgZoomInfo = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-SvgZoomInfo" */ '../../components/colored/ZoomInfo')
);
const TerminalSquare = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-TerminalSquare" */ '../../components/outline/TerminalSquare')
);
const TextAlignCenter = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-TextAlignCenter" */ '../../components/outline/AlignCenter')
);
const TextAlignLeft = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-TextAlignLeft" */ '../../components/outline/AlignLeft')
);
const TextAlignRight = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-TextAlignRight" */ '../../components/outline/AlignRight')
);
const ThumbsDown = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ThumbsDown" */ '../../components/outline/ThumbsDown')
);
const ThumbsUp = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ThumbsUp" */ '../../components/outline/ThumbsUp')
);
const Ticket01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Ticket01" */ '../../components/outline/Ticket01')
);
const Toggle01Right = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Toggle01Right" */ '../../components/outline/Toggle01Right')
);
const Tool02 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Tool02" */ '../../components/outline/Tool02')
);
const Transform = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Transform" */ '../../components/outline/Transform')
);
const Trash01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Trash01" */ '../../components/outline/Trash01')
);
const Type01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Type01" */ '../../components/outline/Type01')
);
const UnifyAi3 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-UnifyAi3" */ '../../components/colored/UnifyAi3')
);
const User01 = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-User01" */ '../../components/outline/User01')
);
const UsersPlus = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-UsersPlus" */ '../../components/outline/UsersPlus')
);
const Verif = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Verif" */ '../../components/colored/Verif')
);
const Warning = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Warning" */ '../../components/colored/Warning')
);
const Webhook = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Webhook" */ '../../components/outline/Webhook')
);
const XCircle = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-XCircle" */ '../../components/outline/XCircle')
);
const Xls = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Xls" */ '../../components/colored/Xls')
);
const Xlsx = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Xlsx" */ '../../components/colored/Xlsx')
);
const Zap = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-Zap" */ '../../components/outline/Zap')
);
const ZapFast = iconLazy(
  () => import(/* webpackChunkName: "ua-icons-ZapFast" */ '../../components/outline/ZapFast')
);

export const iconRegistry: Record<
  string,
  {
    icon?: ComponentType<SVGProps<SVGSVGElement>>;
    label: string;
  }
> = {
  AgenticAiAgents: {
    icon: AgenticAiAgents,
    label: 'AgenticAiAgents',
  },
  AgenticAiApps: {
    icon: AgenticAiApps,
    label: 'AgenticAiApps',
  },
  AgenticAiChat: {
    icon: AgenticAiChat,
    label: 'AgenticAiChat',
  },
  AgenticAiPeople: {
    icon: AgenticAiPeople,
    label: 'AgenticAiPeople',
  },
  AgenticAiSearch: {
    icon: AgenticAiSearch,
    label: 'AgenticAiSearch',
  },
  AISummary: {
    icon: AISummary,
    label: 'AISummary',
  },
  AlertCircle: {
    icon: AlertCircle,
    label: 'Alert Circle',
  },
  AlertTriangle: {
    icon: AlertTriangle,
    label: 'AlertTriangle',
  },
  Announcement03: {
    icon: Announcement03,
    label: 'Announcement',
  },
  Archive: {
    icon: Archive,
    label: 'Archive',
  },
  ArrowCircleBrokenDownRight: {
    icon: ArrowCircleBrokenDownRight,
    label: 'Arrow Circle Broken Down Right',
  },
  ArrowCircleBrokenRight: {
    icon: ArrowCircleBrokenRight,
    label: 'ArrowCircleBrokenRight',
  },
  ArrowCircleBrokenUpRight: {
    icon: ArrowCircleBrokenUpRight,
    label: 'Arrow Circle Broken Up Right',
  },
  ArrowCircleRight: {
    icon: ArrowCircleRight,
    label: 'Arrow Circle Right',
  },
  ArrowCircleUpLeft: {
    icon: ArrowCircleUpLeft,
    label: 'Arrow Circle Up Left',
  },
  ArrowDown: {
    icon: ArrowDown,
    label: 'Arrow Down',
  },
  ArrowDownToLine: {
    icon: ArrowDownToLine,
    label: 'ArrowDownToLine',
  },
  ArrowLeft: {
    icon: ArrowLeft,
    label: 'Arrow Left',
  },
  ArrowLeftToLine: {
    icon: ArrowLeftToLine,
    label: 'ArrowLeftToLine',
  },
  ArrowNarrowDown: {
    icon: ArrowNarrowDown,
    label: 'ArrowNarrowDown',
  },
  ArrowNarrowRight: {
    icon: ArrowNarrowRight,
    label: 'ArrowNarrowRight',
  },
  ArrowRight: {
    icon: ArrowRight,
    label: 'Arrow Right',
  },
  ArrowRightToLine: {
    icon: ArrowRightToLine,
    label: 'ArrowRightToLine',
  },
  ArrowsDown: {
    icon: ArrowsDown,
    label: 'Arrows Down',
  },
  ArrowSquareUpRight: {
    icon: ArrowSquareUpRight,
    label: 'Arrow Square Up Right',
  },
  ArrowsRight: {
    icon: ArrowsRight,
    label: 'Arrows Right',
  },
  ArrowsUp: {
    icon: ArrowsUp,
    label: 'Arrows Up',
  },
  ArrowUp: {
    icon: ArrowUp,
    label: 'Arrow Up',
  },
  ArrowUpToLine: {
    icon: ArrowUpToLine,
    label: 'ArrowUpToLine',
  },
  Atom02: {
    icon: Atom02,
    label: 'Atom',
  },
  AtSign: {
    icon: AtSign,
    label: 'AtSign',
  },
  BarChart10: {
    icon: BarChart10,
    label: 'BarChart10',
  },
  BellNotification: {
    icon: BellNotification,
    label: 'BellNotification',
  },
  Bloomberg: {
    icon: Bloomberg,
    label: 'Bloomberg',
  },
  BracketsCheck: {
    icon: BracketsCheck,
    label: 'BracketsCheck',
  },
  BracketsEllipses: {
    icon: BracketsEllipses,
    label: 'BracketsEllipses',
  },
  BracketsSquare: {
    icon: BracketsSquare,
    label: 'BracketsSquare',
  },
  BriefCase02: {
    icon: BriefCase02,
    label: 'BriefCase02',
  },
  Bug: {
    icon: Bug,
    label: 'Bug',
  },
  Calendar: {
    icon: Calendar,
    label: 'Calendar',
  },
  Chat: {
    icon: Chat,
    label: 'Chat',
  },
  CheckCircleBroken: {
    icon: CheckCircleBroken,
    label: 'Check Circle Broken',
  },
  CheckHeart: {
    icon: CheckHeart,
    label: 'Check Heart',
  },
  ChevronDown: {
    icon: ChevronDown,
    label: 'Chevron Down',
  },
  ChevronDownDouble: {
    icon: ChevronDownDouble,
    label: 'Chevron Down Double',
  },
  ChevronDownSm: {
    icon: ChevronDownSm,
    label: 'Chevron Down Sm',
  },
  ChevronLeft: {
    icon: ChevronLeft,
    label: 'Chevron Left',
  },
  ChevronLeftDouble: {
    icon: ChevronLeftDouble,
    label: 'Chevron Left Double',
  },
  ChevronRight: {
    icon: ChevronRight,
    label: 'Chevron Right',
  },
  ChevronRightDouble: {
    icon: ChevronRightDouble,
    label: 'Chevron Right Double',
  },
  ChevronSelectorVertical: {
    icon: ChevronSelectorVertical,
    label: 'Chevron Selector Vertical',
  },
  ChevronUp: {
    icon: ChevronUp,
    label: 'Chevron Up',
  },
  ChevronUpDouble: {
    icon: ChevronUpDouble,
    label: 'Chevron Up Double',
  },
  Clock: {
    icon: Clock,
    label: 'Clock',
  },
  ClockFastForward: {
    icon: ClockFastForward,
    label: 'ClockFastForward',
  },
  ClockStopwatch: {
    icon: ClockStopwatch,
    label: 'Clock Stopwatch',
  },
  Code01: {
    icon: Code01,
    label: 'Code',
  },
  Code02: {
    icon: Code02,
    label: 'Code 02',
  },
  Codepen: {
    icon: Codepen,
    label: 'Codepen',
  },
  Coins03: {
    icon: Coins03,
    label: 'Coins03',
  },
  CoinsStacked04: {
    icon: CoinsStacked04,
    label: 'CoinsStacked04',
  },
  Container: {
    icon: Container,
    label: 'Container',
  },
  Copy01: {
    icon: Copy01,
    label: 'Copy',
  },
  Cross: {
    icon: Cross,
    label: 'Cross',
  },
  Csv: {
    icon: Csv,
    label: 'Csv',
  },
  Cube02: {
    icon: Cube02,
    label: 'Cube02',
  },
  CursorInteractive: {
    icon: CursorInteractive,
    label: 'CursorInteractive',
  },
  CustomConnector01: {
    icon: CustomConnector01,
    label: 'Custom Connector',
  },
  Database01: {
    icon: Database01,
    label: 'Database',
  },
  Dataflow02: {
    icon: Dataflow02,
    label: 'Dataflow02',
  },
  Dataflow04: {
    icon: Dataflow04,
    label: 'Dataflow 4',
  },
  DataTypeArray: {
    icon: DataTypeArray,
    label: 'DataTypeArray',
  },
  DataTypeArrayZero: {
    icon: DataTypeArrayZero,
    label: 'DataTypeArrayZero',
  },
  DataTypeBinary: {
    icon: DataTypeBinary,
    label: 'DataTypeBinary',
  },
  DataTypeBoolean: {
    icon: DataTypeBoolean,
    label: 'DataTypeBoolean',
  },
  DataTypeDate: {
    icon: DataTypeDate,
    label: 'DataTypeDate',
  },
  DataTypeDatetime: {
    icon: DataTypeDatetime,
    label: 'DataTypeDatetime',
  },
  DataTypeDecimal: {
    icon: DataTypeDecimal,
    label: 'DataTypeDecimal',
  },
  DataTypeDouble: {
    icon: DataTypeDouble,
    label: 'DataTypeDouble',
  },
  DataTypeInteger: {
    icon: DataTypeInteger,
    label: 'DataTypeInteger',
  },
  DataTypeObject: {
    icon: DataTypeObject,
    label: 'DataTypeObject',
  },
  DataTypeText: {
    icon: DataTypeText,
    label: 'DataTypeText',
  },
  DataTypeTime: {
    icon: DataTypeTime,
    label: 'DataTypeTime',
  },
  DataTypeTimestamp: {
    icon: DataTypeTimestamp,
    label: 'DataTypeTimestamp',
  },
  Decimal: {
    icon: Decimal,
    label: 'Decimal',
  },
  Doc: {
    icon: Doc,
    label: 'Doc',
  },
  Docx: {
    icon: Docx,
    label: 'Docx',
  },
  DotsHorizontal: {
    icon: DotsHorizontal,
    label: 'Dots Horizontal',
  },
  DotsVertical: {
    icon: DotsVertical,
    label: 'Dots Vertical',
  },
  Double: {
    icon: Double,
    label: 'Double',
  },
  DualAxesLineChartUp01: {
    icon: DualAxesLineChartUp01,
    label: 'DualAxesLineChartUp01',
  },
  Edit01: {
    icon: Edit01,
    label: 'Edit',
  },
  Edit05: {
    icon: Edit05,
    label: 'Edit',
  },
  Epubs: {
    icon: Epubs,
    label: 'Epubs',
  },
  ErrorOutline: {
    icon: ErrorOutline,
    label: 'Ringed Error',
  },
  Facebook: {
    icon: Facebook,
    label: 'Facebook',
  },
  FaceSmile: {
    icon: FaceSmile,
    label: 'FaceSmile',
  },
  File05: {
    icon: File05,
    label: 'File 05',
  },
  FileDownload03: {
    icon: FileDownload03,
    label: 'FileDownload03',
  },
  FileShield02: {
    icon: FileShield02,
    label: 'File Shield 2',
  },
  FileX03: {
    icon: FileX03,
    label: 'FileX03',
  },
  FilterLines: {
    icon: FilterLines,
    label: 'Filter Lines',
  },
  FolderColored: {
    icon: FolderColored,
    label: 'FolderColored',
  },
  Gauge: {
    icon: Gauge,
    label: 'Gauge',
  },
  GitBranch01: {
    icon: GitBranch01,
    label: 'GitBranch01',
  },
  Globe01: {
    icon: Globe01,
    label: 'Globe01',
  },
  GoogleMaps: {
    icon: GoogleMaps,
    label: 'GoogleMaps',
  },
  Governance: {
    icon: Governance,
    label: 'Governance',
  },
  GridDotsBottom: {
    icon: GridDotsBottom,
    label: 'Grid Dots Bottom',
  },
  GridDotsLeft: {
    icon: GridDotsLeft,
    label: 'Grid Dots Left',
  },
  GridDotsOuter: {
    icon: GridDotsOuter,
    label: 'Grid Dots Outer',
  },
  GridDotsRight: {
    icon: GridDotsRight,
    label: 'Grid Dots Right',
  },
  GridDotsTop: {
    icon: GridDotsTop,
    label: 'Grid Dots Top',
  },
  Hash01: {
    icon: Hash01,
    label: 'Hash',
  },
  Heart: {
    icon: Heart,
    label: 'Heart',
  },
  HeartFilled: {
    icon: HeartFilled,
    label: 'HeartFilled',
  },
  HelpCircle: {
    icon: HelpCircle,
    label: 'Help Circle',
  },
  Home01: {
    icon: Home01,
    label: 'Home',
  },
  Home02: {
    icon: Home02,
    label: 'Home',
  },
  Home03: {
    icon: Home03,
    label: 'Home',
  },
  Home04: {
    icon: Home04,
    label: 'Home',
  },
  Home05: {
    icon: Home05,
    label: 'Home',
  },
  HomeLine: {
    icon: HomeLine,
    label: 'Home',
  },
  HomeSmile: {
    icon: HomeSmile,
    label: 'Home',
  },
  HorizontalBarChart02: {
    icon: HorizontalBarChart02,
    label: 'HorizontalBarChart02',
  },
  InfoCircle: {
    icon: InfoCircle,
    label: 'Info Circle',
  },
  Integer: {
    icon: Integer,
    label: 'Integer',
  },
  IntersectCircle: {
    icon: IntersectCircle,
    label: 'IntersectCircle',
  },
  Json: {
    icon: Json,
    label: 'Json Language',
  },
  Laptop02: {
    icon: Laptop02,
    label: 'Laptop02',
  },
  LayersThree01: {
    icon: LayersThree01,
    label: 'Layers Three 01',
  },
  LayersThree02: {
    icon: LayersThree02,
    label: 'Layers Three 02',
  },
  LayoutAlt01: {
    icon: LayoutAlt01,
    label: 'Layout Alt',
  },
  LayoutAlt04: {
    icon: LayoutAlt04,
    label: 'Layout Alt 4',
  },
  LayoutBottom: {
    icon: LayoutBottom,
    label: 'LayoutBottom',
  },
  LayoutLeft: {
    icon: LayoutLeft,
    label: 'LayoutLeft',
  },
  LayoutRight: {
    icon: LayoutRight,
    label: 'LayoutRight',
  },
  LayoutTop: {
    icon: LayoutTop,
    label: 'LayoutTop',
  },
  LcFileUpload: {
    icon: LcFileUpload,
    label: 'LcFileUpload',
  },
  LcForm: {
    icon: LcForm,
    label: 'LcForm',
  },
  LcSectionColumn: {
    icon: LcSectionColumn,
    label: 'LcSectionColumn',
  },
  LineChartUp01: {
    icon: LineChartUp01,
    label: 'LineChartUp01',
  },
  LineLineChart: {
    icon: LineLineChart,
    label: 'LineLineChart',
  },
  LinkBroken01: {
    icon: LinkBroken01,
    label: 'LinkBroken01',
  },
  Linkedin: {
    icon: Linkedin,
    label: 'Linkedin',
  },
  LinkExternal01: {
    icon: LinkExternal01,
    label: 'LinkExternal01',
  },
  List: {
    icon: List,
    label: 'List',
  },
  Lock03: {
    icon: Lock03,
    label: 'Lock03',
  },
  Logout01: {
    icon: Logout01,
    label: 'Logout',
  },
  Loop: {
    icon: Loop,
    label: 'Loop',
  },
  Mail01: {
    icon: Mail01,
    label: 'Mail',
  },
  Mark: {
    icon: Mark,
    label: 'Mark',
  },
  Menu01: {
    icon: Menu01,
    label: 'Menu',
  },
  MessagePlusSquare: {
    icon: MessagePlusSquare,
    label: 'MessagePlusSquare',
  },
  MessageSmileSquare: {
    icon: MessageSmileSquare,
    label: 'MessageSmileSquare',
  },
  MessageTextSquare02: {
    icon: MessageTextSquare02,
    label: 'MessageTextSquare02',
  },
  Microphone01: {
    icon: Microphone01,
    label: 'Microphone 01',
  },
  Minus: {
    icon: Minus,
    label: 'Minus',
  },
  Monitor01: {
    icon: Monitor01,
    label: ' Monitor01',
  },
  MultiDevice: {
    icon: MultiDevice,
    label: 'MultiDevice',
  },
  NetworkGraph: {
    icon: NetworkGraph,
    label: 'NetworkGraph',
  },
  NoCodeAlert: {
    icon: NoCodeAlert,
    label: 'NoCodeAlert',
  },
  NoCodeAudioPlayer: {
    icon: NoCodeAudioPlayer,
    label: 'NoCodeAudioPlayer',
  },
  NoCodeAvatar: {
    icon: NoCodeAvatar,
    label: 'NoCodeAvatar',
  },
  NoCodeAvatarGroup: {
    icon: NoCodeAvatarGroup,
    label: 'NoCodeAvatarGroup',
  },
  NoCodeBottomsheet: {
    icon: NoCodeBottomsheet,
    label: 'NoCodeBottomsheet',
  },
  NoCodeBusinessHour: {
    icon: NoCodeBusinessHour,
    label: 'NoCodeBusinessHour',
  },
  NoCodeButton: {
    icon: NoCodeButton,
    label: 'NoCodeButton',
  },
  NoCodeButtonGroup: {
    icon: NoCodeButtonGroup,
    label: 'NoCodeButtonGroup',
  },
  NoCodeCalendar: {
    icon: NoCodeCalendar,
    label: 'NoCodeCalendar',
  },
  NoCodeCamera: {
    icon: NoCodeCamera,
    label: 'NoCodeCamera',
  },
  NoCodeCard: {
    icon: NoCodeCard,
    label: 'NoCodeCard',
  },
  NoCodeCarousel: {
    icon: NoCodeCarousel,
    label: 'NoCodeCarousel',
  },
  NoCodeCategoryFilter: {
    icon: NoCodeCategoryFilter,
    label: 'NoCodeCategoryFilter',
  },
  NoCodeChart: {
    icon: NoCodeChart,
    label: 'NoCodeChart',
  },
  NoCodeCheckBox: {
    icon: NoCodeCheckBox,
    label: 'NoCodeCheckBox',
  },
  NoCodeCodeEditor: {
    icon: NoCodeCodeEditor,
    label: 'NoCodeCodeEditor',
  },
  NoCodeCollaboration: {
    icon: NoCodeCollaboration,
    label: 'NoCodeCollaboration',
  },
  NoCodeColorAlert: {
    icon: NoCodeColorAlert,
    label: 'NoCodeColorAlert',
  },
  NoCodeColorAudioPlayer: {
    icon: NoCodeColorAudioPlayer,
    label: 'NoCodeColorAudioPlayer',
  },
  NoCodeColorAvatar: {
    icon: NoCodeColorAvatar,
    label: 'NoCodeColorAvatar',
  },
  NoCodeColorAvatarGroup: {
    icon: NoCodeColorAvatarGroup,
    label: 'NoCodeColorAvatarGroup',
  },
  NoCodeColorBottomsheet: {
    icon: NoCodeColorBottomsheet,
    label: 'NoCodeColorBottomsheet',
  },
  NoCodeColorBusinessHour: {
    icon: NoCodeColorBusinessHour,
    label: 'NoCodeColorBusinessHour',
  },
  NoCodeColorButton: {
    icon: NoCodeColorButton,
    label: 'NoCodeColorButton',
  },
  NoCodeColorButtonGroup: {
    icon: NoCodeColorButtonGroup,
    label: 'NoCodeColorButtonGroup',
  },
  NoCodeColorCalendar: {
    icon: NoCodeColorCalendar,
    label: 'NoCodeColorCalendar',
  },
  NoCodeColorCamera: {
    icon: NoCodeColorCamera,
    label: 'NoCodeColorCamera',
  },
  NoCodeColorCard: {
    icon: NoCodeColorCard,
    label: 'NoCodeColorCard',
  },
  NoCodeColorCarousel: {
    icon: NoCodeColorCarousel,
    label: 'NoCodeColorCarousel',
  },
  NoCodeColorCategoryFilter: {
    icon: NoCodeColorCategoryFilter,
    label: 'NoCodeColorCategoryFilter',
  },
  NoCodeColorChart: {
    icon: NoCodeColorChart,
    label: 'NoCodeColorChart',
  },
  NoCodeColorCodeEditor: {
    icon: NoCodeColorCodeEditor,
    label: 'NoCodeColorCodeEditor',
  },
  NoCodeColorCollaboration: {
    icon: NoCodeColorCollaboration,
    label: 'NoCodeColorCollaboration',
  },
  NoCodeColorComment: {
    icon: NoCodeColorComment,
    label: 'NoCodeColorComment',
  },
  NoCodeColorContainer: {
    icon: NoCodeColorContainer,
    label: 'NoCodeColorContainer',
  },
  NoCodeColorContextualDialog: {
    icon: NoCodeColorContextualDialog,
    label: 'NoCodeColorContextualDialog',
  },
  NoCodeColorCopilot: {
    icon: NoCodeColorCopilot,
    label: 'NoCodeColorCopilot',
  },
  NoCodeColorDatePicker: {
    icon: NoCodeColorDatePicker,
    label: 'NoCodeColorDatePicker',
  },
  NoCodeColorDivider: {
    icon: NoCodeColorDivider,
    label: 'NoCodeColorDivider',
  },
  NoCodeColorEventsCalendar: {
    icon: NoCodeColorEventsCalendar,
    label: 'NoCodeColorEventsCalendar',
  },
  NoCodeColorFileUpload: {
    icon: NoCodeColorFileUpload,
    label: 'NoCodeColorFileUpload',
  },
  NoCodeColorFilters: {
    icon: NoCodeColorFilters,
    label: 'NoCodeColorFilters',
  },
  NoCodeColorForm: {
    icon: NoCodeColorForm,
    label: 'NoCodeColorForm',
  },
  NoCodeColorIcon: {
    icon: NoCodeColorIcon,
    label: 'NoCodeColorIcon',
  },
  NoCodeColorIconButton: {
    icon: NoCodeColorIconButton,
    label: 'NoCodeColorIconButton',
  },
  NoCodeColorIframe: {
    icon: NoCodeColorIframe,
    label: 'NoCodeColorIframe',
  },
  NoCodeColorImage: {
    icon: NoCodeColorImage,
    label: 'NoCodeColorImage',
  },
  NoCodeColorKeyValue: {
    icon: NoCodeColorKeyValue,
    label: 'NoCodeColorKeyValue',
  },
  NoCodeColorLink: {
    icon: NoCodeColorLink,
    label: 'NoCodeColorLink',
  },
  NoCodeColorLoader: {
    icon: NoCodeColorLoader,
    label: 'NoCodeColorLoader',
  },
  NoCodeColorMedia: {
    icon: NoCodeColorMedia,
    label: 'NoCodeColorMedia',
  },
  NoCodeColorMenu: {
    icon: NoCodeColorMenu,
    label: 'NoCodeColorMenu',
  },
  NoCodeColorMessageInput: {
    icon: NoCodeColorMessageInput,
    label: 'NoCodeColorMessageInput',
  },
  NoCodeColorModal: {
    icon: NoCodeColorModal,
    label: 'NoCodeColorModal',
  },
  NoCodeColorMultiStatCard: {
    icon: NoCodeColorMultiStatCard,
    label: 'NoCodeColorMultiStatCard',
  },
  NoCodeColorNavigation: {
    icon: NoCodeColorNavigation,
    label: 'NoCodeColorNavigation',
  },
  NoCodeColorNavigationContainer: {
    icon: NoCodeColorNavigationContainer,
    label: 'NoCodeColorNavigationContainer',
  },
  NoCodeColorNestedTable: {
    icon: NoCodeColorNestedTable,
    label: 'NoCodeColorNestedTable',
  },
  NoCodeColorPdfViewer: {
    icon: NoCodeColorPdfViewer,
    label: 'NoCodeColorPdfViewer',
  },
  NoCodeColorPressable: {
    icon: NoCodeColorPressable,
    label: 'NoCodeColorPressable',
  },
  NoCodeColorProgressBar: {
    icon: NoCodeColorProgressBar,
    label: 'NoCodeColorProgressBar',
  },
  NoCodeColorQrCode: {
    icon: NoCodeColorQrCode,
    label: 'NoCodeColorQrCode',
  },
  NoCodeColorRepeatable: {
    icon: NoCodeColorRepeatable,
    label: 'NoCodeColorRepeatable',
  },
  NoCodeColorRepeatableList: {
    icon: NoCodeColorRepeatableList,
    label: 'NoCodeColorRepeatableList',
  },
  NoCodeColorRichtext: {
    icon: NoCodeColorRichtext,
    label: 'NoCodeColorRichtext',
  },
  NoCodeColorScanner: {
    icon: NoCodeColorScanner,
    label: 'NoCodeColorScanner',
  },
  NoCodeColorSelect: {
    icon: NoCodeColorSelect,
    label: 'NoCodeColorSelect',
  },
  NoCodeColorSideDrawer: {
    icon: NoCodeColorSideDrawer,
    label: 'NoCodeColorSideDrawer',
  },
  NoCodeColorStack: {
    icon: NoCodeColorStack,
    label: 'NoCodeColorStack',
  },
  NoCodeColorStatCard: {
    icon: NoCodeColorStatCard,
    label: 'NoCodeColorStatCard',
  },
  NoCodeColorStatus: {
    icon: NoCodeColorStatus,
    label: 'NoCodeColorStatus',
  },
  NoCodeColorSteppedContainer: {
    icon: NoCodeColorSteppedContainer,
    label: 'NoCodeColorSteppedContainer',
  },
  NoCodeColorStepper: {
    icon: NoCodeColorStepper,
    label: 'NoCodeColorStepper',
  },
  NoCodeColorSwipable: {
    icon: NoCodeColorSwipable,
    label: 'NoCodeColorSwipable',
  },
  NoCodeColorTable: {
    icon: NoCodeColorTable,
    label: 'NoCodeColorTable',
  },
  NoCodeColorTabs: {
    icon: NoCodeColorTabs,
    label: 'NoCodeColorTabs',
  },
  NoCodeColorTag: {
    icon: NoCodeColorTag,
    label: 'NoCodeColorTag',
  },
  NoCodeColorText: {
    icon: NoCodeColorText,
    label: 'NoCodeColorText',
  },
  NoCodeColorTextInput: {
    icon: NoCodeColorTextInput,
    label: 'NoCodeColorTextInput',
  },
  NoCodeColorTimeline: {
    icon: NoCodeColorTimeline,
    label: 'NoCodeColorTimeline',
  },
  NoCodeColorTimer: {
    icon: NoCodeColorTimer,
    label: 'NoCodeColorTimer',
  },
  NoCodeColorVideo: {
    icon: NoCodeColorVideo,
    label: 'NoCodeColorVideo',
  },
  NoCodeColumns3: {
    icon: NoCodeColumns3,
    label: 'NoCodeColumns3',
  },
  NoCodeColumns4: {
    icon: NoCodeColumns4,
    label: 'NoCodeColumns4',
  },
  NoCodeColumns5: {
    icon: NoCodeColumns5,
    label: 'NoCodeColumns5',
  },
  NoCodeColumns6: {
    icon: NoCodeColumns6,
    label: 'NoCodeColumns6',
  },
  NoCodeContainer: {
    icon: NoCodeContainer,
    label: 'NoCodeContainer',
  },
  NoCodeContainer11: {
    icon: NoCodeContainer11,
    label: 'NoCodeContainer11',
  },
  NoCodeContainer112: {
    icon: NoCodeContainer112,
    label: 'NoCodeContainer112',
  },
  NoCodeContainer12: {
    icon: NoCodeContainer12,
    label: 'NoCodeContainer12',
  },
  NoCodeContainer121: {
    icon: NoCodeContainer121,
    label: 'NoCodeContainer121',
  },
  NoCodeContainer13: {
    icon: NoCodeContainer13,
    label: 'NoCodeContainer13',
  },
  NoCodeContainer21: {
    icon: NoCodeContainer21,
    label: 'NoCodeContainer21',
  },
  NoCodeContainer211: {
    icon: NoCodeContainer211,
    label: 'NoCodeContainer211',
  },
  NoCodeContainer23: {
    icon: NoCodeContainer23,
    label: 'NoCodeContainer23',
  },
  NoCodeContainer31: {
    icon: NoCodeContainer31,
    label: 'NoCodeContainer31',
  },
  NoCodeContainer32: {
    icon: NoCodeContainer32,
    label: 'NoCodeContainer32',
  },
  NoCodeContextualDialog: {
    icon: NoCodeContextualDialog,
    label: 'NoCodeContextualDialog',
  },
  NoCodeCopilot: {
    icon: NoCodeCopilot,
    label: 'NoCodeCopilot',
  },
  NoCodeDatePicker: {
    icon: NoCodeDatePicker,
    label: 'NoCodeDatePicker',
  },
  NoCodeDivider: {
    icon: NoCodeDivider,
    label: 'NoCodeDivider',
  },
  NoCodeEventsCalendar: {
    icon: NoCodeEventsCalendar,
    label: 'NoCodeEventsCalendar',
  },
  NoCodeFileUpload: {
    icon: NoCodeFileUpload,
    label: 'NoCodeFileUpload',
  },
  NoCodeFilters: {
    icon: NoCodeFilters,
    label: 'NoCodeFilters',
  },
  NoCodeForm: {
    icon: NoCodeForm,
    label: 'NoCodeForm',
  },
  NoCodeHeatMap: {
    icon: NoCodeHeatMap,
    label: 'NoCodeHeatMap',
  },
  NoCodeIcon: {
    icon: NoCodeIcon,
    label: 'NoCodeIcon',
  },
  NoCodeIconButton: {
    icon: NoCodeIconButton,
    label: 'NoCodeIconButton',
  },
  NoCodeIframe: {
    icon: NoCodeIframe,
    label: 'NoCodeIframe',
  },
  NoCodeImage: {
    icon: NoCodeImage,
    label: 'NoCodeImage',
  },
  NoCodeKeyValue: {
    icon: NoCodeKeyValue,
    label: 'NoCodeKeyValue',
  },
  NoCodeLink: {
    icon: NoCodeLink,
    label: 'NoCodeLink',
  },
  NoCodeLoader: {
    icon: NoCodeLoader,
    label: 'NoCodeLoader',
  },
  NoCodeMedia: {
    icon: NoCodeMedia,
    label: 'NoCodeMedia',
  },
  NoCodeMenu: {
    icon: NoCodeMenu,
    label: 'NoCodeMenu',
  },
  NoCodeMessageInput: {
    icon: NoCodeMessageInput,
    label: 'NoCodeMessageInput',
  },
  NoCodeModal: {
    icon: NoCodeModal,
    label: 'NoCodeModal',
  },
  NoCodeMultiStatCard: {
    icon: NoCodeMultiStatCard,
    label: 'NoCodeMultiStatCard',
  },
  NoCodeNavigation: {
    icon: NoCodeNavigation,
    label: 'NoCodeNavigation',
  },
  NoCodeNavigationContainer: {
    icon: NoCodeNavigationContainer,
    label: 'NoCodeNavigationContainer',
  },
  NoCodeNestedTable: {
    icon: NoCodeNestedTable,
    label: 'NoCodeNestedTable',
  },
  NoCodePdfViewer: {
    icon: NoCodePdfViewer,
    label: 'NoCodePdfViewer',
  },
  NoCodePinnedRightPane: {
    icon: NoCodePinnedRightPane,
    label: 'NoCodePinnedRightPane',
  },
  NoCodeProgressBar: {
    icon: NoCodeProgressBar,
    label: 'NoCodeProgressBar',
  },
  NoCodeQrCode: {
    icon: NoCodeQrCode,
    label: 'NoCodeQrCode',
  },
  NoCodeRepeatable: {
    icon: NoCodeRepeatable,
    label: 'NoCodeRepeatable',
  },
  NoCodeRepeatableList: {
    icon: NoCodeRepeatableList,
    label: 'NoCodeRepeatableList',
  },
  NoCodeRichtext: {
    icon: NoCodeRichtext,
    label: 'NoCodeRichtext',
  },
  NoCodeScanner: {
    icon: NoCodeScanner,
    label: 'NoCodeScanner',
  },
  NoCodeSideDrawer: {
    icon: NoCodeSideDrawer,
    label: 'NoCodeSideDrawer',
  },
  NoCodeStack: {
    icon: NoCodeStack,
    label: 'NoCodeStack',
  },
  NoCodeStatCard: {
    icon: NoCodeStatCard,
    label: 'NoCodeStatCard',
  },
  NoCodeSteppedContainer: {
    icon: NoCodeSteppedContainer,
    label: 'NoCodeSteppedContainer',
  },
  NoCodeStepper: {
    icon: NoCodeStepper,
    label: 'NoCodeStepper',
  },
  NoCodeTable: {
    icon: NoCodeTable,
    label: 'NoCodeTable',
  },
  NoCodeTabs: {
    icon: NoCodeTabs,
    label: 'NoCodeTabs',
  },
  NoCodeTag: {
    icon: NoCodeTag,
    label: 'NoCodeTag',
  },
  NoCodeText: {
    icon: NoCodeText,
    label: 'NoCodeText',
  },
  NoCodeTextInput: {
    icon: NoCodeTextInput,
    label: 'NoCodeTextInput',
  },
  NoCodeTimeline: {
    icon: NoCodeTimeline,
    label: 'NoCodeTimeline',
  },
  NoCodeTimer: {
    icon: NoCodeTimer,
    label: 'NoCodeTimer',
  },
  NoCodeToggle: {
    icon: NoCodeToggle,
    label: 'NoCodeToggle',
  },
  NoCodeVideo: {
    icon: NoCodeVideo,
    label: 'NoCodeVideo',
  },
  NoEntry: {
    icon: NoEntry,
    label: 'No Entry',
  },
  OpenSourceModel: {
    icon: OpenSourceModel,
    label: 'OpenSourceModel',
  },
  PackageCheck: {
    icon: PackageCheck,
    label: 'PackageCheck',
  },
  Paginate: {
    icon: Paginate,
    label: 'Paginate',
  },
  Palette: {
    icon: Palette,
    label: 'Palette',
  },
  Pause: {
    icon: Pause,
    label: 'Pause',
  },
  Pdf2: {
    icon: Pdf2,
    label: 'Pdf2',
  },
  Phone02: {
    icon: Phone02,
    label: 'Phone02',
  },
  PieChart01: {
    icon: PieChart01,
    label: 'Pie Chart',
  },
  Play: {
    icon: Play,
    label: 'Play',
  },
  PlayCircle: {
    icon: PlayCircle,
    label: 'PlayCircle',
  },
  Plus: {
    icon: Plus,
    label: 'Plus',
  },
  Ppt: {
    icon: Ppt,
    label: 'Ppt',
  },
  Pptx: {
    icon: Pptx,
    label: 'Pptx',
  },
  Prohibition: {
    icon: Prohibition,
    label: 'Prohibition',
  },
  QuoteEnd: {
    icon: QuoteEnd,
    label: 'Quote End',
  },
  RadarSpiderChart: {
    icon: RadarSpiderChart,
    label: 'RadarSpiderChart',
  },
  RadialBarChart: {
    icon: RadialBarChart,
    label: 'RadialBarChart',
  },
  RadialColumnChart: {
    icon: RadialColumnChart,
    label: 'RadialColumnChart',
  },
  RadialScatterChart: {
    icon: RadialScatterChart,
    label: 'RadialScatterChart',
  },
  RefreshCcw01: {
    icon: RefreshCcw01,
    label: 'Refresh Ccw 01',
  },
  RefreshCcw02: {
    icon: RefreshCcw02,
    label: 'Refresh Ccw 02',
  },
  RefreshCcw05: {
    icon: RefreshCcw05,
    label: 'Refresh Ccw 05',
  },
  RefreshCw01: {
    icon: RefreshCw01,
    label: 'Refresh Cw 01',
  },
  Reply: {
    icon: Reply,
    label: 'Reply',
  },
  RichText: {
    icon: RichText,
    label: 'RichText',
  },
  Route: {
    icon: Route,
    label: 'route',
  },
  SankeyChart01: {
    icon: SankeyChart01,
    label: 'SankeyChart01',
  },
  SchemaMapping: {
    icon: SchemaMapping,
    label: 'SchemaMapping',
  },
  Scissors01: {
    icon: Scissors01,
    label: 'Scissors',
  },
  Server04: {
    icon: Server04,
    label: 'Server 4',
  },
  SessionStorage: {
    icon: SessionStorage,
    label: 'Session Storage',
  },
  Settings01: {
    icon: Settings01,
    label: 'Settings01',
  },
  Settings04: {
    icon: Settings04,
    label: 'Settings 01',
  },
  Settings05: {
    icon: Settings05,
    label: 'Settings 05',
  },
  Share04: {
    icon: Share04,
    label: 'Share',
  },
  ShieldLock: {
    icon: ShieldLock,
    label: 'ShieldLock',
  },
  SlashCircle01: {
    icon: SlashCircle01,
    label: 'Slash Circle',
  },
  SquareFilled: {
    icon: SquareFilled,
    label: 'SquareFilled',
  },
  Star01: {
    icon: Star01,
    label: 'Star',
  },
  Stars02: {
    icon: Stars02,
    label: 'Stars 2',
  },
  SvgActivity: {
    icon: SvgActivity,
    label: 'Activity',
  },
  SvgAep: {
    icon: SvgAep,
    label: 'SvgAep',
  },
  SvgAi: {
    icon: SvgAi,
    label: 'SvgAi',
  },
  SvgAiAgent: {
    icon: SvgAiAgent,
    label: 'Ai Agent',
  },
  SvgAiTeam: {
    icon: SvgAiTeam,
    label: 'AiTeam',
  },
  SvgAlignHorizontalCenter: {
    icon: SvgAlignHorizontalCenter,
    label: 'AlignHorizontalCenter',
  },
  SvgAlignHorizontalCentre02: {
    icon: SvgAlignHorizontalCentre02,
    label: 'AlignHorizontalCenter02',
  },
  SvgAlignHorizontalEnd: {
    icon: SvgAlignHorizontalEnd,
    label: 'AlignHorizontalEnd',
  },
  SvgAlignHorizontalSpaceBetween: {
    icon: SvgAlignHorizontalSpaceBetween,
    label: 'AlignHorizontalSpaceBetween',
  },
  SvgAlignHorizontalStart: {
    icon: SvgAlignHorizontalStart,
    label: 'AlignHorizontalStart',
  },
  SvgAlignHorizontalStretch: {
    icon: SvgAlignHorizontalStretch,
    label: 'AlignHorizontalStretch',
  },
  SvgAlignLeft02: {
    icon: SvgAlignLeft02,
    label: 'SvgAlignLeft02',
  },
  SvgAlignVerticalCenter: {
    icon: SvgAlignVerticalCenter,
    label: 'AlignVerticalCenter',
  },
  SvgAlignVerticalEnd: {
    icon: SvgAlignVerticalEnd,
    label: 'AlignVerticalEnd',
  },
  SvgAlignVerticalSpaceBetween: {
    icon: SvgAlignVerticalSpaceBetween,
    label: 'AlignVerticalSpaceBetween',
  },
  SvgAlignVerticalStart: {
    icon: SvgAlignVerticalStart,
    label: 'AlignVerticalStart',
  },
  SvgAlignVerticalStretch: {
    icon: SvgAlignVerticalStretch,
    label: 'AlignVerticalStretch',
  },
  SvgAnnotationAlert: {
    icon: SvgAnnotationAlert,
    label: 'Annotation Alert',
  },
  SvgArrowNarrowDownLeft: {
    icon: SvgArrowNarrowDownLeft,
    label: 'SvgArrowNarrowDownLeft',
  },
  SvgArrowNarrowUp: {
    icon: SvgArrowNarrowUp,
    label: 'SvgArrowNarrowUp',
  },
  SvgArrowNarrowUpRight: {
    icon: SvgArrowNarrowUpRight,
    label: 'SvgArrowNarrowUpRight',
  },
  SvgArrowUpRight: {
    icon: SvgArrowUpRight,
    label: 'ArrowUpRight',
  },
  SvgAttachment01: {
    icon: SvgAttachment01,
    label: 'Attachment01',
  },
  SvgAudience: {
    icon: SvgAudience,
    label: 'Audience',
  },
  SvgAudio: {
    icon: SvgAudio,
    label: 'SvgAudio',
  },
  SvgAvi: {
    icon: SvgAvi,
    label: 'SvgAvi',
  },
  SvgAward01: {
    icon: SvgAward01,
    label: 'Award',
  },
  SvgAward05: {
    icon: SvgAward05,
    label: 'Award',
  },
  SvgAzure: {
    icon: SvgAzure,
    label: 'Azure',
  },
  SvgBankNote01: {
    icon: SvgBankNote01,
    label: 'Bank Note 01',
  },
  SvgBankNote02: {
    icon: SvgBankNote02,
    label: 'Bank Note 02',
  },
  SvgBike01: {
    icon: SvgBike01,
    label: 'Bike 01',
  },
  SvgBookClosed: {
    icon: SvgBookClosed,
    label: 'SvgBookClosed',
  },
  SvgBookOpen01: {
    icon: SvgBookOpen01,
    label: 'SvgBookOpen01',
  },
  SvgBracketsX: {
    icon: SvgBracketsX,
    label: 'BracketsX',
  },
  SvgCalculator: {
    icon: SvgCalculator,
    label: 'Calculator',
  },
  SvgCalculator02: {
    icon: SvgCalculator02,
    label: 'Calculator02',
  },
  SvgCalendar: {
    icon: SvgCalendar,
    label: 'Calendar',
  },
  SvgCalendarClock: {
    icon: SvgCalendarClock,
    label: 'Calendar Clock',
  },
  SvgCar02: {
    icon: SvgCar02,
    label: 'Car 02',
  },
  SvgCatalog: {
    icon: SvgCatalog,
    label: 'Catalog',
  },
  SvgCertificate02: {
    icon: SvgCertificate02,
    label: 'Certificate02',
  },
  SvgChartBreakoutCircle1: {
    icon: SvgChartBreakoutCircle1,
    label: 'ChartBreakoutCircle1',
  },
  SvgChatView: {
    icon: SvgChatView,
    label: 'SvgChatView',
  },
  SvgCheck: {
    icon: SvgCheck,
    label: 'Check',
  },
  SvgCheckCircle: {
    icon: SvgCheckCircle,
    label: 'Check Circle',
  },
  SvgCheckSquare: {
    icon: SvgCheckSquare,
    label: 'Check Square',
  },
  SvgCheckVerified02: {
    icon: SvgCheckVerified02,
    label: 'Check Verified',
  },
  SvgClipboardCheck: {
    icon: SvgClipboardCheck,
    label: 'Clipboard Check',
  },
  SvgClock: {
    icon: SvgClock,
    label: 'Clock',
  },
  SvgClockCheck: {
    icon: SvgClockCheck,
    label: 'Clock Check',
  },
  SvgClockFastForward: {
    icon: SvgClockFastForward,
    label: 'SvgClockFastForward',
  },
  SvgClockRewind: {
    icon: SvgClockRewind,
    label: 'Clock Rewind',
  },
  SvgCode: {
    icon: SvgCode,
    label: 'SvgCode',
  },
  SvgCodeBrowser: {
    icon: SvgCodeBrowser,
    label: 'SvgCodeBrowser',
  },
  SvgCodeCircle01: {
    icon: SvgCodeCircle01,
    label: 'SvgCodeCircle01',
  },
  SvgColumns03: {
    icon: SvgColumns03,
    label: 'Columns03',
  },
  SvgCornerDownLeft: {
    icon: SvgCornerDownLeft,
    label: 'Corner Down Left',
  },
  SvgCreditCardLock: {
    icon: SvgCreditCardLock,
    label: 'CreditCardLock',
  },
  SvgCreditCardMinus: {
    icon: SvgCreditCardMinus,
    label: 'Credit Card Minus',
  },
  SvgCreditCardPlus: {
    icon: SvgCreditCardPlus,
    label: 'Credit Card Plus',
  },
  SvgCryptocurrency01: {
    icon: SvgCryptocurrency01,
    label: 'Cryptocurrency',
  },
  SvgCss: {
    icon: SvgCss,
    label: 'SvgCss',
  },
  SvgCsv: {
    icon: SvgCsv,
    label: 'SvgCsv',
  },
  SvgCurrencyDollar: {
    icon: SvgCurrencyDollar,
    label: 'Currency Dollar',
  },
  SvgCurrencyDollarCircle: {
    icon: SvgCurrencyDollarCircle,
    label: 'CurrencyDollarCircle',
  },
  SvgCurrencyEuro: {
    icon: SvgCurrencyEuro,
    label: 'Currency Euro',
  },
  SvgCurrencyPound: {
    icon: SvgCurrencyPound,
    label: 'Currency Pound',
  },
  SvgCurrencyRuble: {
    icon: SvgCurrencyRuble,
    label: 'Currency Ruble',
  },
  SvgCurrencyRupee: {
    icon: SvgCurrencyRupee,
    label: 'Currency Rupee',
  },
  SvgCurrencyYen: {
    icon: SvgCurrencyYen,
    label: 'Currency Yen',
  },
  SvgData: {
    icon: SvgData,
    label: 'SvgData',
  },
  SvgDatabase02: {
    icon: SvgDatabase02,
    label: 'Database 2',
  },
  SvgDatabase03: {
    icon: SvgDatabase03,
    label: 'Database03',
  },
  SvgDataflow01: {
    icon: SvgDataflow01,
    label: 'Dataflow',
  },
  SvgDetokenisation: {
    icon: SvgDetokenisation,
    label: 'Detokenisation',
  },
  SvgDmg: {
    icon: SvgDmg,
    label: 'SvgDmg',
  },
  SvgDoc: {
    icon: SvgDoc,
    label: 'SvgDoc',
  },
  SvgDocument: {
    icon: SvgDocument,
    label: 'SvgDocument',
  },
  SvgDocx: {
    icon: SvgDocx,
    label: 'SvgDocx',
  },
  SvgDot: {
    icon: SvgDot,
    label: 'Dot',
  },
  SvgDownload01: {
    icon: SvgDownload01,
    label: 'Download',
  },
  SvgDownloadCloud02: {
    icon: SvgDownloadCloud02,
    label: 'Download Cloud',
  },
  SvgEdit03: {
    icon: SvgEdit03,
    label: 'Edit',
  },
  SvgEps: {
    icon: SvgEps,
    label: 'SvgEps',
  },
  SvgEpubs: {
    icon: SvgEpubs,
    label: 'SvgEpubs',
  },
  SvgEraser: {
    icon: SvgEraser,
    label: 'Eraser',
  },
  SvgExe: {
    icon: SvgExe,
    label: 'SvgExe',
  },
  SvgExpand03: {
    icon: SvgExpand03,
    label: 'SvgExpand03',
  },
  SvgEye: {
    icon: SvgEye,
    label: 'Eye',
  },
  SvgEyeOff: {
    icon: SvgEyeOff,
    label: 'Eye Off',
  },
  SvgFaceId: {
    icon: SvgFaceId,
    label: 'Face Id',
  },
  SvgFig: {
    icon: SvgFig,
    label: 'SvgFig',
  },
  SvgFile02: {
    icon: SvgFile02,
    label: 'File',
  },
  SvgFileCheck02: {
    icon: SvgFileCheck02,
    label: 'File Check',
  },
  SvgFileCheck03: {
    icon: SvgFileCheck03,
    label: 'File Check',
  },
  SvgFileCode01: {
    icon: SvgFileCode01,
    label: 'SvgFileCode01',
  },
  SvgFileLock02: {
    icon: SvgFileLock02,
    label: 'SvgFileLock02',
  },
  SvgFileSearch02: {
    icon: SvgFileSearch02,
    label: 'SvgFileSearch02',
  },
  SvgFingerprint04: {
    icon: SvgFingerprint04,
    label: 'Fingerprint04',
  },
  SvgFolder: {
    icon: SvgFolder,
    label: 'SvgFolder',
  },
  SvgFolder02: {
    icon: SvgFolder02,
    label: 'SvgFolder02',
  },
  SvgFolderPlus: {
    icon: SvgFolderPlus,
    label: 'FolderPlus',
  },
  SvgFolderQuestion: {
    icon: SvgFolderQuestion,
    label: 'Folder Question',
  },
  SvgFolderX: {
    icon: SvgFolderX,
    label: 'FolderX',
  },
  SvgFunction: {
    icon: SvgFunction,
    label: 'Function',
  },
  SvgGif: {
    icon: SvgGif,
    label: 'SvgGif',
  },
  SvgGoogle: {
    icon: SvgGoogle,
    label: 'Google',
  },
  SvgGoogleMeet: {
    icon: SvgGoogleMeet,
    label: 'GoogleMeet',
  },
  SvgGrid01: {
    icon: SvgGrid01,
    label: 'Grid',
  },
  SvgGridPlus: {
    icon: SvgGridPlus,
    label: 'Grid Plus',
  },
  SvgGroovyLanguage: {
    icon: SvgGroovyLanguage,
    label: 'Groovy Language',
  },
  SvgHanger: {
    icon: SvgHanger,
    label: 'Hanger',
  },
  SvgHighlighter: {
    icon: SvgHighlighter,
    label: 'SvgHighlighter',
  },
  SvgHtml: {
    icon: SvgHtml,
    label: 'SvgHtml',
  },
  SvgHubspot: {
    icon: SvgHubspot,
    label: 'Hubspot',
  },
  SvgImage: {
    icon: SvgImage,
    label: 'SvgImage',
  },
  SvgImg: {
    icon: SvgImg,
    label: 'SvgImg',
  },
  SvgIndd: {
    icon: SvgIndd,
    label: 'SvgIndd',
  },
  SvgInfoSquare: {
    icon: SvgInfoSquare,
    label: 'SvgInfoSquare',
  },
  SvgJava: {
    icon: SvgJava,
    label: 'SvgJava',
  },
  SvgJavaLanguage: {
    icon: SvgJavaLanguage,
    label: 'Java Language',
  },
  SvgJpeg: {
    icon: SvgJpeg,
    label: 'SvgJpeg',
  },
  SvgJpg: {
    icon: SvgJpg,
    label: 'SvgJpg',
  },
  SvgJs: {
    icon: SvgJs,
    label: 'SvgJs',
  },
  SvgJsLanguage: {
    icon: SvgJsLanguage,
    label: 'Js Language',
  },
  SvgJson: {
    icon: SvgJson,
    label: 'SvgJson',
  },
  SvgJsonLanguage: {
    icon: SvgJsonLanguage,
    label: 'Json Language',
  },
  SvgJsonSchemaLanguage: {
    icon: SvgJsonSchemaLanguage,
    label: 'Json Schema Language',
  },
  SvgJwtValidation: {
    icon: SvgJwtValidation,
    label: 'JwtValidation',
  },
  SvgKey01: {
    icon: SvgKey01,
    label: 'Key',
  },
  SvgLayoutGrid02: {
    icon: SvgLayoutGrid02,
    label: 'Layout Grid',
  },
  SvgLayoutTop: {
    icon: SvgLayoutTop,
    label: 'LayoutTop',
  },
  SvgLcIcon: {
    icon: SvgLcIcon,
    label: 'LcIcon',
  },
  SvgLcIconButton: {
    icon: SvgLcIconButton,
    label: 'LcIconButton',
  },
  SvgLcLink: {
    icon: SvgLcLink,
    label: 'LcLink',
  },
  SvgLcProgressBar: {
    icon: SvgLcProgressBar,
    label: 'LcProgressBar',
  },
  SvgLcTimeline: {
    icon: SvgLcTimeline,
    label: 'SvgLcTimeline',
  },
  SvgLdap: {
    icon: SvgLdap,
    label: 'Ldap',
  },
  SvgLightbulb02: {
    icon: SvgLightbulb02,
    label: 'SvgLightbulb02',
  },
  SvgLightbulb05: {
    icon: SvgLightbulb05,
    label: 'SvgLightbulb05',
  },
  SvgLineChartUp03: {
    icon: SvgLineChartUp03,
    label: 'LineChartUp',
  },
  SvgLink01: {
    icon: SvgLink01,
    label: 'Link',
  },
  SvgLocation: {
    icon: SvgLocation,
    label: 'Location',
  },
  SvgLock01: {
    icon: SvgLock01,
    label: 'Lock',
  },
  SvgLoop: {
    icon: SvgLoop,
    label: 'Loop',
  },
  SvgMarkerPin01: {
    icon: SvgMarkerPin01,
    label: 'MarkerPin',
  },
  SvgMedicalCross: {
    icon: SvgMedicalCross,
    label: 'MedicalCross',
  },
  SvgMessageChatSquare: {
    icon: SvgMessageChatSquare,
    label: 'SvgMessageChatSquare',
  },
  SvgMessageHeartSquare: {
    icon: SvgMessageHeartSquare,
    label: 'MessageHeartSquare',
  },
  SvgMessageSquare02: {
    icon: SvgMessageSquare02,
    label: 'SvgMessageSquare02',
  },
  SvgMessageTextSquare01: {
    icon: SvgMessageTextSquare01,
    label: 'SvgMessageTextSquare01',
  },
  SvgMicrosoft: {
    icon: SvgMicrosoft,
    label: 'Microsoft',
  },
  SvgMicrosoftTeams: {
    icon: SvgMicrosoftTeams,
    label: 'SvgMicrosoftTeams',
  },
  SvgMp3: {
    icon: SvgMp3,
    label: 'SvgMp3',
  },
  SvgMp4: {
    icon: SvgMp4,
    label: 'SvgMp4',
  },
  SvgMpeg: {
    icon: SvgMpeg,
    label: 'SvgMpeg',
  },
  SvgMultiSelect: {
    icon: SvgMultiSelect,
    label: 'Multi Select',
  },
  SvgNoCodeBottomsheet: {
    icon: SvgNoCodeBottomsheet,
    label: 'NoCodeBottomsheet',
  },
  SvgNoCodeCascader: {
    icon: SvgNoCodeCascader,
    label: 'SvgNoCodeCascader',
  },
  SvgNoCodeColorCascader: {
    icon: SvgNoCodeColorCascader,
    label: 'SvgNoCodeColorCascader',
  },
  SvgNoCodeColorCheckbox: {
    icon: SvgNoCodeColorCheckbox,
    label: 'SvgNoCodeColorCheckbox',
  },
  SvgNoCodeColorImageGrid: {
    icon: SvgNoCodeColorImageGrid,
    label: 'SvgNoCodeColorImageGrid',
  },
  SvgNoCodeColorToggle: {
    icon: SvgNoCodeColorToggle,
    label: 'SvgNoCodeCheckbox',
  },
  SvgNoCodeForm: {
    icon: SvgNoCodeForm,
    label: 'NoCodeForm',
  },
  SvgNoCodeImageGrid: {
    icon: SvgNoCodeImageGrid,
    label: 'SvgNoCodeImageGrid',
  },
  SvgNoCodeSideDrawer: {
    icon: SvgNoCodeSideDrawer,
    label: 'NoCodeSideDrawer',
  },
  SvgNotification: {
    icon: SvgNotification,
    label: 'Notification',
  },
  SvgNotificationText: {
    icon: SvgNotificationText,
    label: 'NotificationText',
  },
  SvgOkta: {
    icon: SvgOkta,
    label: 'Okta',
  },
  SvgOkta02: {
    icon: SvgOkta02,
    label: 'Okta02',
  },
  SvgOpenId: {
    icon: SvgOpenId,
    label: 'OpenId',
  },
  SvgOtel: {
    icon: SvgOtel,
    label: 'SvgOtel',
  },
  SvgOutlineFolder: {
    icon: SvgOutlineFolder,
    label: 'SvgOutlineFolder',
  },
  SvgPackage: {
    icon: SvgPackage,
    label: 'Package',
  },
  SvgPage: {
    icon: SvgPage,
    label: 'Page',
  },
  SvgPageVariables: {
    icon: SvgPageVariables,
    label: 'Page Variables',
  },
  SvgPaintPour: {
    icon: SvgPaintPour,
    label: 'Paint Pour',
  },
  SvgPaperAirplane: {
    icon: SvgPaperAirplane,
    label: 'PaperAirplane',
  },
  SvgPasscode: {
    icon: SvgPasscode,
    label: 'Passcode',
  },
  SvgPasscodeLock: {
    icon: SvgPasscodeLock,
    label: 'Passcode Lock',
  },
  SvgPdf: {
    icon: SvgPdf,
    label: 'SvgPdf',
  },
  SvgPencil01: {
    icon: SvgPencil01,
    label: 'Pencil',
  },
  SvgPeople: {
    icon: SvgPeople,
    label: 'People',
  },
  SvgPercent02: {
    icon: SvgPercent02,
    label: 'Percent',
  },
  SvgPhone: {
    icon: SvgPhone,
    label: 'Phone',
  },
  SvgPhone01: {
    icon: SvgPhone01,
    label: 'SvgPhone01',
  },
  SvgPhone02: {
    icon: SvgPhone02,
    label: 'SvgPhone02',
  },
  SvgPipeline01: {
    icon: SvgPipeline01,
    label: 'SvgPipeline01',
  },
  SvgPlayCircle: {
    icon: SvgPlayCircle,
    label: 'PlayCircle',
  },
  SvgPng: {
    icon: SvgPng,
    label: 'SvgPng',
  },
  SvgPpt: {
    icon: SvgPpt,
    label: 'SvgPpt',
  },
  SvgPptx: {
    icon: SvgPptx,
    label: 'SvgPptx',
  },
  SvgPsd: {
    icon: SvgPsd,
    label: 'SvgPsd',
  },
  SvgPuzzlePiece02: {
    icon: SvgPuzzlePiece02,
    label: 'SvgPuzzlePiece02',
  },
  SvgPythonLanguage: {
    icon: SvgPythonLanguage,
    label: 'Python Language',
  },
  SvgQuotes: {
    icon: SvgQuotes,
    label: 'Quote Start',
  },
  SvgRadioSelect: {
    icon: SvgRadioSelect,
    label: 'Radio Select',
  },
  SvgRar: {
    icon: SvgRar,
    label: 'SvgRar',
  },
  SvgRequestTransformer: {
    icon: SvgRequestTransformer,
    label: 'Request Transformer',
  },
  SvgResetPassword: {
    icon: SvgResetPassword,
    label: 'ResetPassword',
  },
  SvgReverseLeft: {
    icon: SvgReverseLeft,
    label: 'SvgReverseLeft',
  },
  SvgRocket02: {
    icon: SvgRocket02,
    label: 'rocket',
  },
  SvgRows01: {
    icon: SvgRows01,
    label: 'Rows 01',
  },
  SvgRss: {
    icon: SvgRss,
    label: 'SvgRss',
  },
  SvgSalesforce: {
    icon: SvgSalesforce,
    label: 'Salesforce',
  },
  SvgSearchMd: {
    icon: SvgSearchMd,
    label: 'SvgSearchMd',
  },
  SvgSearchRefraction: {
    icon: SvgSearchRefraction,
    label: 'SvgSearchRefraction',
  },
  SvgSearchStar02: {
    icon: SvgSearchStar02,
    label: 'SvgSearchStar02',
  },
  SvgSettings01: {
    icon: SvgSettings01,
    label: 'Settings 02',
  },
  SvgShare07: {
    icon: SvgShare07,
    label: 'Share',
  },
  SvgShield02: {
    icon: SvgShield02,
    label: 'Shield',
  },
  SvgShield03: {
    icon: SvgShield03,
    label: 'Shield03',
  },
  SvgShieldTick: {
    icon: SvgShieldTick,
    label: 'ShieldTick',
  },
  SvgShoppingBag02: {
    icon: SvgShoppingBag02,
    label: 'Shopping Bag 02',
  },
  SvgShuffle01: {
    icon: SvgShuffle01,
    label: 'Shuffle01',
  },
  SvgSignal01: {
    icon: SvgSignal01,
    label: 'Signal',
  },
  SvgSignal02: {
    icon: SvgSignal02,
    label: 'Signal 02',
  },
  SvgSignal03: {
    icon: SvgSignal03,
    label: 'Signal03',
  },
  SvgSimcard: {
    icon: SvgSimcard,
    label: 'Simcard',
  },
  SvgSingleSelect: {
    icon: SvgSingleSelect,
    label: 'Single Select',
  },
  SvgSlack: {
    icon: SvgSlack,
    label: 'Slack',
  },
  SvgSliders04: {
    icon: SvgSliders04,
    label: 'SvgSliders04',
  },
  SvgSpeedometer01: {
    icon: SvgSpeedometer01,
    label: 'Speedometer',
  },
  SvgSpeedometer03: {
    icon: SvgSpeedometer03,
    label: 'Speedometer',
  },
  SvgSpreadsheet: {
    icon: SvgSpreadsheet,
    label: 'SvgSpreadsheet',
  },
  SvgSprinklr: {
    icon: SvgSprinklr,
    label: 'SvgSprinklr',
  },
  SvgSql: {
    icon: SvgSql,
    label: 'SvgSql',
  },
  SvgStar02: {
    icon: SvgStar02,
    label: 'Star',
  },
  SvgStar04: {
    icon: SvgStar04,
    label: 'SvgStar04',
  },
  SvgStar07: {
    icon: SvgStar07,
    label: 'Star',
  },
  SvgStepComplete: {
    icon: SvgStepComplete,
    label: 'StepComplete',
  },
  SvgStepCurrent: {
    icon: SvgStepCurrent,
    label: 'StepCurrent',
  },
  SvgStepError: {
    icon: SvgStepError,
    label: 'StepError',
  },
  SvgStepIncomplete: {
    icon: SvgStepIncomplete,
    label: 'StepIncomplete',
  },
  SvgStore: {
    icon: SvgStore,
    label: 'Store',
  },
  SvgSupport: {
    icon: SvgSupport,
    label: 'Support',
  },
  SvgSvg: {
    icon: SvgSvg,
    label: 'SvgSvg',
  },
  SvgSwitchOff: {
    icon: SvgSwitchOff,
    label: 'SvgSwitchOff',
  },
  SvgSwitchOn: {
    icon: SvgSwitchOn,
    label: 'SvgSwitchOn',
  },
  SvgTablet01: {
    icon: SvgTablet01,
    label: 'SvgTablet01',
  },
  SvgTabletHorizontal: {
    icon: SvgTabletHorizontal,
    label: 'SvgTabletHorizontal',
  },
  SvgTag01: {
    icon: SvgTag01,
    label: 'Tag',
  },
  SvgTarget: {
    icon: SvgTarget,
    label: 'SvgTarget',
  },
  SvgTelescope: {
    icon: SvgTelescope,
    label: 'SvgTelescope',
  },
  SvgTerminalBrowser: {
    icon: SvgTerminalBrowser,
    label: 'SvgTerminalBrowser',
  },
  SvgTextInput: {
    icon: SvgTextInput,
    label: 'TextInput',
  },
  SvgTiff: {
    icon: SvgTiff,
    label: 'SvgTiff',
  },
  SvgTool01: {
    icon: SvgTool01,
    label: 'SvgTool01',
  },
  SvgTrain: {
    icon: SvgTrain,
    label: 'Train',
  },
  SvgTranslate02: {
    icon: SvgTranslate02,
    label: 'Translate',
  },
  SvgTrash01: {
    icon: SvgTrash01,
    label: 'Trash',
  },
  SvgTxt: {
    icon: SvgTxt,
    label: 'SvgTxt',
  },
  SvgUnifyAi: {
    icon: SvgUnifyAi,
    label: 'SvgUnifyAi',
  },
  SvgUnifyApi: {
    icon: SvgUnifyApi,
    label: 'Unify Api',
  },
  SvgUpload01: {
    icon: SvgUpload01,
    label: 'Upload 01',
  },
  SvgUploadCloud02: {
    icon: SvgUploadCloud02,
    label: 'Upload Cloud',
  },
  SvgUserCheck01: {
    icon: SvgUserCheck01,
    label: 'SvgUserCheck01',
  },
  SvgUserPlus01: {
    icon: SvgUserPlus01,
    label: 'UserPlus01',
  },
  SvgUserRight01: {
    icon: SvgUserRight01,
    label: 'UserRight01',
  },
  SvgUsers01: {
    icon: SvgUsers01,
    label: 'Users',
  },
  SvgUsersCheck: {
    icon: SvgUsersCheck,
    label: 'Users Check',
  },
  SvgUsersRight: {
    icon: SvgUsersRight,
    label: 'UsersRight',
  },
  SvgUsersX: {
    icon: SvgUsersX,
    label: 'UsersX',
  },
  SvgVariable: {
    icon: SvgVariable,
    label: 'Variable',
  },
  SvgVideo01: {
    icon: SvgVideo01,
    label: 'SvgVideo01',
  },
  SvgWav: {
    icon: SvgWav,
    label: 'SvgWav',
  },
  SvgWebp: {
    icon: SvgWebp,
    label: 'SvgWebp',
  },
  SvgWhatsapp: {
    icon: SvgWhatsapp,
    label: 'Whatsapp',
  },
  SvgXClose: {
    icon: SvgXClose,
    label: 'Close',
  },
  SvgXLogo: {
    icon: SvgXLogo,
    label: 'SvgXLogo',
  },
  SvgXls: {
    icon: SvgXls,
    label: 'SvgXls',
  },
  SvgXml: {
    icon: SvgXml,
    label: 'SvgXml',
  },
  SvgXmlLanguage: {
    icon: SvgXmlLanguage,
    label: 'Xml Language',
  },
  SvgZapOff: {
    icon: SvgZapOff,
    label: 'ZapOff',
  },
  SvgZip: {
    icon: SvgZip,
    label: 'SvgZip',
  },
  SvgZoom: {
    icon: SvgZoom,
    label: 'Zoom',
  },
  SvgZoomInfo: {
    icon: SvgZoomInfo,
    label: 'ZoomInfo',
  },
  TerminalSquare: {
    icon: TerminalSquare,
    label: 'TerminalSquare',
  },
  TextAlignCenter: {
    icon: TextAlignCenter,
    label: 'TextAlignCenter',
  },
  TextAlignLeft: {
    icon: TextAlignLeft,
    label: 'TextAlignLeft',
  },
  TextAlignRight: {
    icon: TextAlignRight,
    label: 'TextAlignRight',
  },
  ThumbsDown: {
    icon: ThumbsDown,
    label: 'ThumbsDown',
  },
  ThumbsUp: {
    icon: ThumbsUp,
    label: 'ThumbsUp',
  },
  Ticket01: {
    icon: Ticket01,
    label: 'Ticket',
  },
  Toggle01Right: {
    icon: Toggle01Right,
    label: 'Toggle01Right',
  },
  Tool02: {
    icon: Tool02,
    label: 'Tool',
  },
  Transform: {
    icon: Transform,
    label: 'Transform',
  },
  Trash01: {
    icon: Trash01,
    label: 'Trash01',
  },
  Type01: {
    icon: Type01,
    label: 'Type',
  },
  UnifyAi3: {
    icon: UnifyAi3,
    label: 'UnifyAi3',
  },
  User01: {
    icon: User01,
    label: 'User',
  },
  UsersPlus: {
    icon: UsersPlus,
    label: 'UsersPlus',
  },
  Verif: {
    icon: Verif,
    label: 'Verif',
  },
  Warning: {
    icon: Warning,
    label: 'Warning',
  },
  Webhook: {
    icon: Webhook,
    label: 'Webhook',
  },
  XCircle: {
    icon: XCircle,
    label: 'XCircle',
  },
  Xls: {
    icon: Xls,
    label: 'Xls',
  },
  Xlsx: {
    icon: Xlsx,
    label: 'Xlsx',
  },
  Zap: {
    icon: Zap,
    label: 'Zap',
  },
  ZapFast: {
    icon: ZapFast,
    label: 'Zap Fast',
  },
};
